'use strict';

window.LogicCraft = window.LogicCraft || {};

window.LogicCraft.ui = (function() {
    const state = window.LogicCraft.state;
    const core = window.LogicCraft.core;
    const sim = window.LogicCraft.simulation;

    let challengeCategory = 'fase-1';
    let currentChIdx = 0;
    let challengeModeOpen = false;
    let selectedQuizOption = null;
    let completedPhases = [];
    const PHASES_ORDER = ['fase-1', 'fase-2', 'fase-3', 'fase-4', 'fase-5', 'fase-6', 'fase-7', 'fase-8', 'fase-9', 'fase-10'];

    function isPhaseUnlocked(phaseId) {
        const idx = PHASES_ORDER.indexOf(phaseId);
        if (idx <= 0) return true; // Fase 1 is always unlocked
        return completedPhases.includes(PHASES_ORDER[idx - 1]);
    }

    function updatePhaseButtonsUI() {
        PHASES_ORDER.forEach((id, idx) => {
            const btn = document.getElementById('btn-cat-' + id);
            if (!btn) return;
            const phaseNum = idx + 1;
            const isCompleted = completedPhases.includes(id);
            const isUnlocked = isPhaseUnlocked(id);

            btn.classList.toggle('completed', isCompleted);
            btn.classList.toggle('locked', !isUnlocked);

            if (isCompleted) {
                btn.textContent = `⭐ F${phaseNum}`;
                btn.title = `Fase ${phaseNum} Concluída! Clique para jogar novamente.`;
            } else if (isUnlocked) {
                btn.textContent = `F${phaseNum}`;
                btn.title = `Fase ${phaseNum} Desbloqueada! Clique para jogar.`;
            } else {
                btn.textContent = `🔒 F${phaseNum}`;
                btn.title = `Fase ${phaseNum} Bloqueada! Complete a Fase ${phaseNum - 1} primeiro.`;
            }
        });

        const progressPct = Math.round((completedPhases.length / PHASES_ORDER.length) * 100);
        const pBar = document.getElementById('ch-progress-bar');
        if (pBar) {
            pBar.style.width = Math.max(10, progressPct) + '%';
        }
    }

    function loadCompletedPhases() {
        if (window.LogicCraftGuard && typeof window.LogicCraftGuard.loadProgress === 'function') {
            const prog = window.LogicCraftGuard.loadProgress();
            if (prog && Array.isArray(prog)) completedPhases = prog;
        } else {
            const raw = localStorage.getItem('logiccraft_progress');
            if (raw) {
                try { completedPhases = JSON.parse(raw); } catch(e){}
            }
        }
        updatePhaseButtonsUI();
    }

    function markPhaseCompleted(phaseId) {
        if (!completedPhases.includes(phaseId)) {
            completedPhases.push(phaseId);
            if (window.LogicCraftGuard && typeof window.LogicCraftGuard.saveProgress === 'function') {
                window.LogicCraftGuard.saveProgress(completedPhases);
            } else {
                localStorage.setItem('logiccraft_progress', JSON.stringify(completedPhases));
            }
        }
        updatePhaseButtonsUI();
    }

    function bindClick(id, callback) {
        const el = document.getElementById(id);
        if (el) el.addEventListener('click', callback);
    }

    function showPersistentToast(type, msg) {
        const wrap = document.getElementById('toast-wrap');
        if (!wrap) return null;
        
        const t = document.createElement('div');
        t.className = `toast ${type}`;
        
        const content = document.createElement('div');
        content.className = 'toast-content';
        const b = document.createElement('b');
        b.textContent = type.toUpperCase();
        content.appendChild(b);
        content.appendChild(document.createTextNode(': '));
        const lines = String(msg).split('\n');
        lines.forEach((line, idx) => {
            if (idx > 0) content.appendChild(document.createElement('br'));
            content.appendChild(document.createTextNode(line));
        });

        const btnClose = document.createElement('button');
        btnClose.className = 'toast-close';
        btnClose.textContent = '×';
        btnClose.setAttribute('aria-label', 'Fechar notificação');
        
        t.appendChild(content);
        t.appendChild(btnClose);
        wrap.appendChild(t);

        const isError = (type === 'error');
        const duration = isError ? 8000 : 3600;

        let autoCloseTimeout;
        const removeToast = () => {
            clearTimeout(autoCloseTimeout);
            t.classList.add('fade-out');
            setTimeout(() => t.remove(), 250);
        };

        btnClose.addEventListener('click', removeToast);
        autoCloseTimeout = setTimeout(removeToast, duration);
        return t;
    }

    function showToast(type, msg) {
        showPersistentToast(type, msg);
    }

    function togglePointerHint(show) {
        const hint = document.getElementById('pointer-hint');
        if (hint) {
            hint.style.opacity = show ? '1' : '0';
        }
    }

    function formatBooleanTerm(rawTerm) {
        if (!rawTerm) return '';
        return rawTerm
            .replace(/¬([A-D])/g, '<span class="var-over">$1</span>')
            .replace(/\s*·\s*/g, '');
    }

    const PALETTE_DATA = [
        { category: 'ENTRADAS DIGITAIS & CONTROLE' },
        { type: core.COMP.SWITCH, sw: 'A', label: 'Chave A', sub: 'Entrada 0 ou 1 (Bit 3 / Peso 8)', key: '2' },
        { type: core.COMP.SWITCH, sw: 'B', label: 'Chave B', sub: 'Entrada 0 ou 1 (Bit 2 / Peso 4)', key: '3' },
        { type: core.COMP.SWITCH, sw: 'C', label: 'Chave C', sub: 'Entrada 0 ou 1 (Bit 1 / Peso 2)', key: '4' },
        { type: core.COMP.SWITCH, sw: 'D', label: 'Chave D', sub: 'Entrada 0 ou 1 (Bit 0 / Peso 1)', key: '5' },
        { type: core.COMP.PUSH_BUTTON_NO, label: 'Botão NA', sub: 'Normalmente aberto (Pulso HIGH)' },
        { type: core.COMP.PUSH_BUTTON_NC, label: 'Botão NF', sub: 'Normalmente fechado (Pulso LOW)' },
        { type: core.COMP.EMERGENCY_STOP, label: 'Botão de emergência', sub: 'Trava ao acionar (Girar p/ soltar)' },

        { category: 'CONDUTORES & INTERCONEXÃO' },
        { type: core.COMP.WIRE, label: 'Trilha', sub: 'Condutor na placa', key: '1' },
        { type: core.COMP.JUMPER, label: 'Jumper', sub: 'Cruza sinais sem curto', key: '6' },
        { type: 'AIR_WIRE', label: 'Fio', sub: 'Conecta pinos elétricos', key: 'C' },
        { type: 'HOSE', label: 'Mangueira', sub: 'Conecta portas de fluido', key: 'M' },

        { category: 'PORTAS LÓGICAS (74XX)' },
        { type: core.COMP.AND, label: 'Porta AND', sub: 'Operação E (7408)', key: '7' },
        { type: core.COMP.OR, label: 'Porta OR', sub: 'Operação OU (7432)', key: '8' },
        { type: core.COMP.NOT, label: 'Porta NOT', sub: 'Inversor (7404)', key: '9' },
        { type: core.COMP.XOR, label: 'Porta XOR', sub: 'Ou exclusivo (7486)', key: '0' },
        { type: core.COMP.NAND, label: 'Porta NAND', sub: 'E negada (7400)' },
        { type: core.COMP.NOR, label: 'Porta NOR', sub: 'OU negada (7402)' },
        { type: core.COMP.XNOR, label: 'Porta XNOR', sub: 'Coincidência (74266)' },
        { type: core.COMP.BUFFER, label: 'Buffer', sub: 'Isolador de sinal (7407)' },

        { category: 'BLOCOS DIGITAIS & SAÍDAS' },
        { type: core.COMP.DEC_BCD_7SEG, label: 'Decodificador BCD', sub: 'Controla os 7 segmentos' },
        { type: core.COMP.DISPLAY_7SEG, label: 'Display de 7 segmentos', sub: 'Exibe dígitos' },
        { type: core.COMP.LAMP, label: 'Lâmpada', sub: 'Indicador luminoso' },
        { type: core.COMP.LED_RED, label: 'LED', sub: 'Indicador luminoso' },
        { type: core.COMP.BUZZER, label: 'Buzzer', sub: 'Alarme sonoro' },

        { category: 'TEMPORIZAÇÃO & INTERFACE' },
        { type: core.COMP.RELAY, label: 'Relé', sub: 'Bobina e contatos' },
        { type: core.COMP.TIMER_TON, label: 'Temporizador TON', sub: 'Atraso para ligar (2.0s)' },

        { category: 'COMANDOS ELÉTRICOS & POTÊNCIA' },
        {
            type: core.COMP.POWER_SUPPLY_3P,
            label: 'Fonte trifásica',
            sub: 'Rede 380V/220V + Terra',
            desc: 'Rede 380V/220V (L1, L2, L3, N, PE) com Seccionadora'
        },
        {
            type: core.COMP.CONTACTOR_3P,
            label: 'Contator',
            sub: 'Chave eletromagnética (K1)',
            desc: 'Bobina A1/A2 24Vdc, Contatos Principais 1-6 e Auxiliar 13-14'
        },
        { type: core.COMP.MOTOR_INDUCTION_6P, label: 'Motor trifásico', sub: 'Indução trifásica' },
        { type: core.COMP.MOTOR_INDUCTION_MONO, label: 'Motor monofásico', sub: 'Partida por capacitor' },

        { category: 'SISTEMAS FLUÍDICOS & ELETROPNEUMÁTICA' },
        { type: core.COMP.SUPPLY_PNEU, label: 'Unidade FRL', sub: 'Filtro e pressão 6 bar' },
        { type: core.COMP.SUPPLY_HYDRA, label: 'Unidade hidráulica', sub: 'Bomba e tanque 120 bar' },
        { type: core.COMP.VALVE_3_2_MONO, label: 'Válvula 3/2 monoestável', sub: 'Retorno por mola' },
        { type: core.COMP.VALVE_5_2_MONO, label: 'Válvula 5/2 monoestável', sub: 'Retorno por mola' },
        { type: core.COMP.VALVE_5_2_BI, label: 'Válvula 5/2 biestável', sub: 'Duplo solenoide' },
        { type: core.COMP.VALVE_4_2_MONO, label: 'Válvula 4/2 monoestável', sub: 'Retorno por mola' },
        { type: core.COMP.VALVE_4_2_BI, label: 'Válvula 4/2 biestável', sub: 'Duplo solenoide' },
        { type: core.COMP.VALVE_FLOW_CONTROL, label: 'Reguladora de fluxo', sub: 'Ajusta o fluxo' },
        { type: core.COMP.CYL_SINGLE, label: 'Cilindro simples ação', sub: 'Retorno por mola' },
        { type: core.COMP.CYL_DOUBLE, label: 'Cilindro pneumático', sub: 'Dupla ação' },
        { type: core.COMP.CYL_HYDRA, label: 'Cilindro hidráulico', sub: 'Dupla ação' }
    ];

    function getComponentThumbnail(type, switchId) {
        const svgStart = `<svg viewBox="0 0 40 40" fill="none" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">`;
        if (type === 'AIR_WIRE') return `${svgStart}<path d="M8 28 C14 8, 26 8, 32 28" stroke="#38BDF8" stroke-width="2.5"/><circle cx="8" cy="28" r="3" fill="#38BDF8"/><circle cx="32" cy="28" r="3" fill="#FFC400"/></svg>`;
        if (type === 'HOSE') return `${svgStart}<path d="M6 30 C12 6, 28 6, 34 30" stroke="#00E5FF" stroke-width="3.5"/><circle cx="6" cy="30" r="3.5" fill="#D97706"/><circle cx="34" cy="30" r="3.5" fill="#D97706"/></svg>`;
        if (type === core.COMP.WIRE) return `${svgStart}<line x1="8" y1="20" x2="32" y2="20" stroke="#1677F2" stroke-width="3"/><circle cx="20" cy="20" r="3" fill="#FFC400"/></svg>`;
        if (type === core.COMP.JUMPER) return `${svgStart}<path d="M8 20 L14 20 Q20 6 26 20 L32 20" stroke="#FFC400" stroke-width="2.5"/><circle cx="20" cy="11" r="2.5" fill="#1677F2"/></svg>`;
        if (type === core.COMP.SWITCH) {
            const conf = core.INPUT_CONFIG.find(c => c.id === switchId);
            const switchColor = conf ? conf.hex : '#1677F2';
            return `${svgStart}<rect x="10" y="8" width="20" height="24" rx="4" stroke="${switchColor}" fill="rgba(22, 119, 242, 0.1)"/><circle cx="20" cy="16" r="4" fill="${switchColor}"/><line x1="20" y1="20" x2="20" y2="26" stroke="${switchColor}" stroke-width="2"/></svg>`;
        }
        if (type === core.COMP.PUSH_BUTTON_NO) {
            return `${svgStart}<line x1="8" y1="20" x2="16" y2="20" stroke="#22C55E"/><line x1="24" y1="20" x2="32" y2="20" stroke="#22C55E"/><line x1="16" y1="14" x2="24" y2="14" stroke="#22C55E" stroke-width="2.5"/><line x1="20" y1="14" x2="20" y2="8" stroke="#22C55E"/><circle cx="20" cy="8" r="3" fill="#22C55E"/></svg>`;
        }
        if (type === core.COMP.PUSH_BUTTON_NC) {
            return `${svgStart}<line x1="8" y1="20" x2="16" y2="20" stroke="#EF4444"/><line x1="24" y1="20" x2="32" y2="20" stroke="#EF4444"/><line x1="16" y1="20" x2="24" y2="20" stroke="#EF4444" stroke-width="2.5"/><line x1="20" y1="20" x2="20" y2="8" stroke="#EF4444"/><circle cx="20" cy="8" r="3" fill="#EF4444"/></svg>`;
        }
        if (type === core.COMP.EMERGENCY_STOP) {
            return `${svgStart}<circle cx="20" cy="14" r="8" fill="#DC2626" stroke="#FACC15" stroke-width="2"/><line x1="20" y1="22" x2="20" y2="28" stroke="#FACC15" stroke-width="2.5"/><line x1="10" y1="28" x2="30" y2="28" stroke="#FACC15"/></svg>`;
        }
        if (type === core.COMP.RELAY) return `${svgStart}<rect x="8" y="8" width="24" height="24" rx="3" stroke="#22A06B" fill="rgba(34, 160, 107, 0.15)"/><line x1="12" y1="20" x2="20" y2="20" stroke="#FFC400"/><line x1="20" y1="20" x2="28" y2="14" stroke="#FFC400"/></svg>`;
        if (type === core.COMP.TIMER_TON) {
            return `${svgStart}<rect x="8" y="8" width="24" height="24" rx="3" stroke="#F59E0B" fill="rgba(245, 158, 11, 0.15)"/><line x1="12" y1="12" x2="20" y2="28" stroke="#F59E0B"/><text x="23" y="24" font-size="8" fill="#F59E0B" font-weight="bold" font-family="monospace">TON</text></svg>`;
        }
        if (type === core.COMP.AND || type === core.COMP.NAND) return `${svgStart}<path d="M10 10 h8 a10 10 0 0 1 0 20 h-8 z" stroke="#1677F2" fill="rgba(22, 119, 242, 0.15)"/>${type === core.COMP.NAND ? '<circle cx="30" cy="20" r="2.5" stroke="#FFC400" fill="#FFC400"/>' : ''}</svg>`;
        if (type === core.COMP.OR || type === core.COMP.NOR) return `${svgStart}<path d="M8 10 q8 10 0 20 q12 0 18 -10 q-6 -10 -18 -10" stroke="#258AF5" fill="rgba(37, 138, 245, 0.15)"/>${type === core.COMP.NOR ? '<circle cx="29" cy="20" r="2.5" stroke="#FFC400" fill="#FFC400"/>' : ''}</svg>`;
        if (type === core.COMP.XOR || type === core.COMP.XNOR) return `${svgStart}<path d="M12 10 q8 10 0 20 q12 0 18 -10 q-6 -10 -18 -10" stroke="#D946EF" fill="rgba(217, 70, 239, 0.15)"/><path d="M7 10 q8 10 0 20" stroke="#D946EF"/>${type === core.COMP.XNOR ? '<circle cx="31" cy="20" r="2.5" stroke="#FFC400" fill="#FFC400"/>' : ''}</svg>`;
        if (type === core.COMP.NOT) return `${svgStart}<polygon points="10,10 10,30 26,20" stroke="#FFC400" fill="rgba(255, 196, 0, 0.15)"/><circle cx="29" cy="20" r="2.5" stroke="#FFC400" fill="#FFC400"/></svg>`;
        if (type === core.COMP.BUFFER) return `${svgStart}<polygon points="10,10 10,30 28,20" stroke="#22A06B" fill="rgba(34, 160, 107, 0.15)"/></svg>`;
        if (type === core.COMP.DEC_BCD_7SEG) return `${svgStart}<rect x="6" y="10" width="28" height="20" rx="3" stroke="#258AF5" fill="rgba(37, 138, 245, 0.15)"/><text x="20" y="23" font-size="8" fill="#FFC400" font-weight="bold" text-anchor="middle" font-family="monospace">BCD</text></svg>`;
        if (type === core.COMP.DISPLAY_7SEG) return `${svgStart}<rect x="8" y="6" width="24" height="28" rx="4" stroke="#62738D" fill="#07152F"/><text x="20" y="27" font-size="16" fill="#D64545" font-weight="bold" text-anchor="middle" font-family="monospace">8</text></svg>`;
        if (type === core.COMP.LAMP || type === core.COMP.LED_RED) {
            const isRed = (type === core.COMP.LED_RED);
            const lampColor = isRed ? '#D64545' : '#FFC400';
            return `${svgStart}<circle cx="20" cy="20" r="9" stroke="${lampColor}" fill="${isRed ? 'rgba(214, 69, 69, 0.2)' : 'rgba(255, 196, 0, 0.2)'}"/><line x1="14" y1="14" x2="26" y2="26" stroke="${lampColor}"/><line x1="26" y1="14" x2="14" y2="26" stroke="${lampColor}"/></svg>`;
        }
        if (type === core.COMP.BUZZER) return `${svgStart}<path d="M12 16 L18 16 L24 10 L24 30 L18 24 L12 24 Z" stroke="#E59B00" fill="rgba(229, 155, 0, 0.2)"/><path d="M28 14 Q32 20 28 26" stroke="#E59B00"/></svg>`;
        if (type === core.COMP.SOLENOID_PNEU || type === core.COMP.SOLENOID_HYDRA) {
            const isPneu = (type === core.COMP.SOLENOID_PNEU);
            const solColor = isPneu ? '#258AF5' : '#102F67';
            return `${svgStart}<rect x="8" y="12" width="24" height="16" rx="2" stroke="${solColor}" fill="rgba(37, 138, 245, 0.2)"/><line x1="8" y1="12" x2="32" y2="28" stroke="#FFC400" stroke-width="2"/></svg>`;
        }
        if (type === core.COMP.VALVE_3_2_MONO) {
            return `${svgStart}<rect x="4" y="14" width="4" height="12" stroke="#38BDF8" fill="rgba(56, 189, 248, 0.2)"/><line x1="4" y1="26" x2="8" y2="14" stroke="#38BDF8"/><rect x="8" y="12" width="11" height="16" stroke="#38BDF8" fill="none"/><rect x="19" y="12" width="11" height="16" stroke="#38BDF8" fill="none"/><path d="M30 20 L32 16 L34 24 L36 20" stroke="#94A3B8" fill="none"/><line x1="11" y1="24" x2="16" y2="16" stroke="#00E5FF"/><line x1="22" y1="24" x2="26" y2="24" stroke="#00E5FF"/><line x1="24" y1="24" x2="24" y2="20" stroke="#00E5FF"/><line x1="26" y1="16" x2="26" y2="22" stroke="#00E5FF"/></svg>`;
        }
        if (type === core.COMP.VALVE_5_2_MONO) {
            return `${svgStart}<rect x="4" y="14" width="4" height="12" stroke="#38BDF8" fill="rgba(56, 189, 248, 0.2)"/><line x1="4" y1="26" x2="8" y2="14" stroke="#38BDF8"/><rect x="8" y="12" width="11" height="16" stroke="#38BDF8" fill="none"/><rect x="19" y="12" width="11" height="16" stroke="#38BDF8" fill="none"/><path d="M30 20 L32 16 L34 24 L36 20" stroke="#94A3B8" fill="none"/><line x1="11" y1="24" x2="16" y2="16" stroke="#00E5FF"/><line x1="16" y1="24" x2="11" y2="16" stroke="#00E5FF"/><line x1="22" y1="24" x2="22" y2="16" stroke="#00E5FF"/><line x1="27" y1="24" x2="27" y2="16" stroke="#00E5FF"/></svg>`;
        }
        if (type === core.COMP.VALVE_5_2_BI) {
            return `${svgStart}<rect x="4" y="14" width="4" height="12" stroke="#38BDF8" fill="rgba(56, 189, 248, 0.2)"/><line x1="4" y1="26" x2="8" y2="14" stroke="#38BDF8"/><rect x="8" y="12" width="11" height="16" stroke="#38BDF8" fill="none"/><rect x="19" y="12" width="11" height="16" stroke="#38BDF8" fill="none"/><rect x="30" y="14" width="4" height="12" stroke="#38BDF8" fill="rgba(56, 189, 248, 0.2)"/><line x1="30" y1="26" x2="34" y2="14" stroke="#38BDF8"/><line x1="11" y1="24" x2="16" y2="16" stroke="#00E5FF"/><line x1="16" y1="24" x2="11" y2="16" stroke="#00E5FF"/></svg>`;
        }
        if (type === core.COMP.VALVE_4_2_MONO) {
            return `${svgStart}<rect x="4" y="14" width="4" height="12" stroke="#F59E0B" fill="rgba(245, 158, 11, 0.2)"/><line x1="4" y1="26" x2="8" y2="14" stroke="#F59E0B"/><rect x="8" y="12" width="11" height="16" stroke="#F59E0B" fill="none"/><rect x="19" y="12" width="11" height="16" stroke="#F59E0B" fill="none"/><path d="M30 20 L32 16 L34 24 L36 20" stroke="#94A3B8" fill="none"/><line x1="11" y1="24" x2="16" y2="16" stroke="#F59E0B"/><line x1="16" y1="24" x2="11" y2="16" stroke="#F59E0B"/><line x1="22" y1="24" x2="22" y2="16" stroke="#F59E0B"/><line x1="27" y1="24" x2="27" y2="16" stroke="#F59E0B"/></svg>`;
        }
        if (type === core.COMP.VALVE_4_2_BI) {
            return `${svgStart}<rect x="4" y="14" width="4" height="12" stroke="#F59E0B" fill="rgba(245, 158, 11, 0.2)"/><line x1="4" y1="26" x2="8" y2="14" stroke="#F59E0B"/><rect x="8" y="12" width="11" height="16" stroke="#F59E0B" fill="none"/><rect x="19" y="12" width="11" height="16" stroke="#F59E0B" fill="none"/><rect x="30" y="14" width="4" height="12" stroke="#F59E0B" fill="rgba(245, 158, 11, 0.2)"/><line x1="30" y1="26" x2="34" y2="14" stroke="#F59E0B"/><line x1="11" y1="24" x2="16" y2="16" stroke="#F59E0B"/><line x1="16" y1="24" x2="11" y2="16" stroke="#F59E0B"/></svg>`;
        }
        if (type === core.COMP.VALVE_FLOW_CONTROL) {
            return `${svgStart}<rect x="8" y="12" width="24" height="16" rx="2" stroke="#0284C7" fill="rgba(2, 132, 199, 0.15)"/><line x1="12" y1="20" x2="28" y2="20" stroke="#38BDF8"/><line x1="20" y1="14" x2="20" y2="26" stroke="#F59E0B" stroke-width="2.5"/><polygon points="18,14 22,14 20,10" fill="#F59E0B"/></svg>`;
        }
        if (core.VALVE_TYPES.has(type)) {
            return `${svgStart}<rect x="8" y="12" width="11" height="16" stroke="#22C55E" fill="rgba(34, 160, 107, 0.15)"/><rect x="19" y="12" width="11" height="16" stroke="#22C55E" fill="rgba(34, 160, 107, 0.15)"/><line x1="14" y1="16" x2="14" y2="24" stroke="#FFC400"/></svg>`;
        }
        if (type === core.COMP.SUPPLY_PNEU) {
            return `${svgStart}<rect x="8" y="10" width="24" height="22" rx="3" stroke="#00E5FF" fill="rgba(0, 229, 255, 0.15)"/><circle cx="20" cy="18" r="6" stroke="#00E5FF"/><line x1="20" y1="18" x2="23" y2="15" stroke="#FFC400" stroke-width="1.8"/><text x="20" y="30" font-size="6" fill="#00E5FF" font-weight="bold" text-anchor="middle" font-family="monospace">6 BAR</text></svg>`;
        }
        if (type === core.COMP.SUPPLY_HYDRA) {
            return `${svgStart}<rect x="8" y="14" width="24" height="18" rx="2" stroke="#F59E0B" fill="rgba(245, 158, 11, 0.15)"/><rect x="12" y="8" width="16" height="6" rx="1" stroke="#F59E0B"/><circle cx="20" cy="22" r="4" stroke="#F59E0B"/><line x1="20" y1="22" x2="22" y2="20" stroke="#FFC400" stroke-width="1.8"/><text x="20" y="30" font-size="5" fill="#F59E0B" font-weight="bold" text-anchor="middle" font-family="monospace">120 BAR</text></svg>`;
        }
        if (type === core.COMP.CYL_SINGLE) {
            return `${svgStart}<rect x="6" y="12" width="18" height="16" rx="2" stroke="#38BDF8" fill="rgba(56, 189, 248, 0.15)"/><path d="M10 16 L12 24 L14 16 L16 24 L18 16" stroke="#94A3B8" fill="none"/><line x1="24" y1="20" x2="35" y2="20" stroke="#FFC400" stroke-width="3"/>`;
        }
        if (core.CYLINDER_TYPES.has(type)) {
            const isHydra = (type === core.COMP.CYL_HYDRA);
            const cylColor = isHydra ? '#102F67' : '#258AF5';
            return `${svgStart}<rect x="6" y="12" width="18" height="16" rx="2" stroke="${cylColor}" fill="rgba(37, 138, 245, 0.2)"/><line x1="24" y1="20" x2="35" y2="20" stroke="#FFC400" stroke-width="3"/><rect x="33" y="17" width="3" height="6" fill="#FFC400"/></svg>`;
        }
        if (type === core.COMP.MOTOR_INDUCTION_6P) {
            return `${svgStart}<rect x="8" y="10" width="24" height="20" rx="3" stroke="#38BDF8" fill="rgba(56, 189, 248, 0.15)"/><circle cx="20" cy="20" r="7" stroke="#38BDF8"/><text x="20" y="23" font-size="7" fill="#38BDF8" font-weight="bold" text-anchor="middle" font-family="monospace">3~M</text><line x1="27" y1="20" x2="35" y2="20" stroke="#FFC400" stroke-width="2.5"/></svg>`;
        }
        if (type === core.COMP.MOTOR_INDUCTION_MONO) {
            return `${svgStart}<rect x="8" y="12" width="24" height="18" rx="3" stroke="#F59E0B" fill="rgba(245, 158, 11, 0.15)"/><rect x="12" y="6" width="16" height="6" rx="2" stroke="#38BDF8" fill="rgba(56, 189, 248, 0.3)"/><circle cx="20" cy="21" r="6" stroke="#F59E0B"/><text x="20" y="23.5" font-size="6" fill="#F59E0B" font-weight="bold" text-anchor="middle" font-family="monospace">1~M</text><line x1="27" y1="21" x2="35" y2="21" stroke="#FFC400" stroke-width="2.5"/></svg>`;
        }
        if (type === core.COMP.CONTACTOR_3P) {
            return `${svgStart}<rect x="8" y="8" width="24" height="24" rx="2" stroke="#38BDF8" fill="rgba(30, 41, 59, 0.6)"/><rect x="14" y="14" width="12" height="12" fill="#EA580C" rx="1"/><text x="20" y="12" font-size="4.5" fill="#38BDF8" font-weight="bold" text-anchor="middle" font-family="monospace">K1 3P</text></svg>`;
        }
        if (type === core.COMP.POWER_SUPPLY_3P) {
            return `${svgStart}<rect x="6" y="10" width="28" height="20" rx="2" stroke="#EF4444" fill="rgba(239, 68, 68, 0.15)"/><circle cx="12" cy="18" r="3" fill="#EF4444"/><circle cx="20" cy="18" r="3" fill="#F59E0B"/><circle cx="28" cy="18" r="3" fill="#22C55E"/><text x="20" y="27" font-size="5" fill="#F8FAFC" font-weight="bold" text-anchor="middle" font-family="monospace">380V PE</text></svg>`;
        }

        return `${svgStart}<rect x="10" y="10" width="20" height="20" rx="3" stroke="#1677F2" fill="rgba(22, 119, 242, 0.1)"/></svg>`;
    }

    function updateInputCountUI() {
        const configRow = document.querySelector('.config-row');
        const curType = state.currentSelection.type;
        const isSingleInputGate = (curType === core.COMP.NOT || curType === core.COMP.BUFFER);
        const isMultiInputGate = (
            curType === core.COMP.AND ||
            curType === core.COMP.OR ||
            curType === core.COMP.NAND ||
            curType === core.COMP.NOR ||
            curType === core.COMP.XOR ||
            curType === core.COMP.XNOR
        );
        const isGate = isSingleInputGate || isMultiInputGate;

        if (!configRow) return;

        if (!isGate) {
            configRow.style.display = 'none';
            return;
        }

        configRow.style.display = 'flex';

        const countBtns = document.querySelectorAll('.btn-count');
        if (isSingleInputGate) {
            state.currentSelection.inputCount = 1;
            countBtns.forEach(btn => {
                const val = Number.parseInt(btn.dataset.in, 10);
                if (val === 1) {
                    btn.disabled = false;
                    btn.classList.add('active');
                } else {
                    btn.disabled = true;
                    btn.classList.remove('active');
                }
            });
        } else if (isMultiInputGate) {
            if (state.currentSelection.inputCount === 1 || !state.currentSelection.inputCount) {
                state.currentSelection.inputCount = 2;
            }
            countBtns.forEach(btn => {
                const val = Number.parseInt(btn.dataset.in, 10);
                if (val === 1) {
                    btn.disabled = true;
                    btn.classList.remove('active');
                } else {
                    btn.disabled = false;
                    btn.classList.toggle('active', val === state.currentSelection.inputCount);
                }
            });
        }
    }

    function selectPaletteItem(item) {
        state.currentSelection.type = item.type;
        if (item.sw) state.currentSelection.switchId = item.sw;
        if (item.type === 'AIR_WIRE') {
            showToast('info', 'Modo Cabo Air Wire ativo: clique no pino de saída e depois no pino de entrada.');
            updateInputCountUI();
            buildPaletteUI();
            return;
        }
        if (item.type === 'HOSE') {
            showToast('info', 'Modo Mangueira Manual ativo: clique no niple de origem e depois no niple de destino.');
            updateInputCountUI();
            buildPaletteUI();
            return;
        }
        if (item.type === core.COMP.NOT || item.type === core.COMP.BUFFER || item.type === core.COMP.JUMPER || item.type === core.COMP.TIMER_TON) state.currentSelection.inputCount = 1;
        else if (core.BUTTON_TYPES.has(item.type) || (core.SUPPLY_TYPES && core.SUPPLY_TYPES.has(item.type)) || (core.MACHINE_TYPES && core.MACHINE_TYPES.has(item.type))) state.currentSelection.inputCount = 0;
        else if (item.type === core.COMP.DEC_BCD_7SEG) state.currentSelection.inputCount = 4;
        else if (item.type === core.COMP.DISPLAY_7SEG) state.currentSelection.inputCount = 7;
        else if (item.type === core.COMP.RELAY) state.currentSelection.inputCount = 2;
        else if (core.GATE_TYPES.has(item.type) && state.currentSelection.inputCount === 1) state.currentSelection.inputCount = 2;
        
        updateInputCountUI();
        buildPaletteUI();
    }

    function buildPaletteUI() {
        const wrap = document.getElementById('palette-list');
        if (!wrap) return;

        if (!wrap._hasDelegatedListener) {
            wrap.addEventListener('click', (e) => {
                const slot = e.target.closest('.slot');
                if (!slot) return;
                const idx = slot.dataset.paletteIndex;
                if (idx !== undefined && PALETTE_DATA[idx]) {
                    selectPaletteItem(PALETTE_DATA[idx]);
                }
            });
            wrap._hasDelegatedListener = true;
        }

        const frag = document.createDocumentFragment();
        PALETTE_DATA.forEach((item, index) => {
            if (item.category) {
                const cat = document.createElement('div');
                cat.className = 'palette-category-title';
                cat.textContent = item.category;
                frag.appendChild(cat);
                return;
            }
            const slot = document.createElement('div');
            const isSwMatch = !item.sw || item.sw === state.currentSelection.switchId;
            const isActive = (item.type === state.currentSelection.type && isSwMatch);
            slot.className = 'slot' + (isActive ? ' active' : '');
            slot.dataset.paletteIndex = index;
            
            const svgIcon = item.icon || getComponentThumbnail(item.type, item.sw);
            const subText = item.sub || item.desc || '';
            slot.innerHTML = `<div class="slot-thumbnail">${svgIcon}</div>
                              <div class="slot-info"><span class="slot-title">${item.label}</span><span class="slot-sub">${subText}</span></div>
                              ${item.key ? `<span class="slot-kbd" title="Tecla de atalho: ${item.key}">[${item.key}]</span>` : ''}`;
            
            frag.appendChild(slot);
        });
        wrap.innerHTML = '';
        wrap.appendChild(frag);
    }

    function initKeyboardShortcuts() {
        document.addEventListener('keydown', (e) => {
            if (e.target.tagName === 'INPUT' || e.target.tagName === 'TEXTAREA' || e.target.isContentEditable) return;
            
            if ((e.ctrlKey || e.metaKey) && e.key.toLowerCase() === 'z' && !e.shiftKey) {
                e.preventDefault();
                sim.undoLastAction();
                return;
            }
            if ((e.ctrlKey || e.metaKey) && (e.key.toLowerCase() === 'y' || (e.shiftKey && e.key.toLowerCase() === 'z'))) {
                e.preventDefault();
                sim.redoLastAction();
                return;
            }

            if (e.ctrlKey || e.metaKey || e.altKey) return;
            if (document.getElementById('modal-screen')?.classList.contains('open') || document.getElementById('onboarding-screen')?.classList.contains('open')) return;

            // Ativação dinâmica dos atalhos registrados na paleta (1..6, 7..0, C, M, etc.)
            const pressedKey = e.key.toUpperCase();
            const matchedItem = PALETTE_DATA.find(it => it.key && it.key.toUpperCase() === pressedKey);
            if (matchedItem) {
                selectPaletteItem(matchedItem);
                return;
            }

            if (e.key === 'Escape') {
                state.lockedInspectionNodeKey = null;
                return;
            }

            if (e.key === 'Tab') {
                e.preventDefault();
                const left = document.getElementById('hud-left');
                const right = document.getElementById('hud-right');
                const willCollapse = !(left.classList.contains('is-collapsed') && right.classList.contains('is-collapsed'));
                left.classList.toggle('is-collapsed', willCollapse);
                right.classList.toggle('is-collapsed', willCollapse);
            }
        });
    }

    function initCollapsiblePanels() {
        const toggleLeft = document.getElementById('toggle-left-btn');
        const leftPanel = document.getElementById('hud-left');
        if (toggleLeft && leftPanel) {
            toggleLeft.onclick = (e) => {
                if (e) e.stopPropagation();
                leftPanel.classList.toggle('is-collapsed');
            };
        }

        const toggleRight = document.getElementById('toggle-right-btn');
        const rightPanel = document.getElementById('hud-right');
        if (toggleRight && rightPanel) {
            toggleRight.onclick = (e) => {
                if (e) e.stopPropagation();
                rightPanel.classList.toggle('is-collapsed');
            };
        }
    }

    const FUNDAMENTALS_CHALLENGES = [
        {
            title: "01. Palavra Binária 1010₂",
            desc: "Ajuste as chaves na bancada para formar 1010₂ (Nibble ABCD).",
            type: 'word',
            expected: '1010',
            hint: "Chaves necessárias: A=1, B=0, C=1, D=0.",
            feedbackOk: "Correto! 1010₂ equivale a 10 em decimal e A em hexadecimal."
        }
    ];

    const SIMPLIFICATION_CHALLENGES = [
        {
            title: "01. Identidade Booleana",
            desc: "Simplifique a expressão booleana: A + ¬A",
            type: 'quiz',
            options: ["0", "1", "A", "¬A"],
            answer: 1,
            hint: "Se A for 0, ¬A é 1. Em operação OU, qualquer entrada em HIGH resulta em 1.",
            feedbackOk: "Perfeito! Postulado da complementaridade: A + ¬A = 1.",
            feedbackFail: "Incorreto. Em álgebra booleana, uma variável somada com seu complemento é sempre 1."
        },
        {
            title: "02. Teorema de De Morgan",
            desc: "Qual expressão é logicamente equivalente a ¬(A · B)?",
            type: 'quiz',
            options: ["¬A · ¬B", "¬A + ¬B", "A + B", "¬(A + B)"],
            answer: 1,
            hint: "A negação de uma operação AND vira uma operação OR com as entradas negadas.",
            feedbackOk: "Correto! ¬(A · B) = ¬A + ¬B (Primeiro Teorema de De Morgan).",
            feedbackFail: "Incorreto. De Morgan transforma a multiplicação de entradas em soma de complementos."
        }
    ];

    const BCD_CHALLENGES = [
        {
            title: "01. Exibir o Dígito Decimal 7",
            desc: "Configure as chaves A, B, C e D para formar o dígito decimal 7 no Display de 7 Segmentos.",
            type: 'word',
            expected: '0111',
            hint: "O número 7 requer a soma dos pesos 4 + 2 + 1 (B=1, C=1, D=1).",
            feedbackOk: "Excelente! 0111₂ = 7₁₀. O decodificador acendeu os segmentos a, b e c com sucesso!"
        }
    ];

    const PNEU_CHALLENGES = [
        {
            title: "01. Comando Bimanual de Segurança (NR-12)",
            desc: "Monte na bancada um circuito para o cilindro 2A avançar SOMENTE quando as chaves A E B forem acionadas simultaneamente (Y1 = A · B).",
            type: 'testbench',
            switches: ['A', 'B'],
            targetType: core.COMP.SOLENOID_PNEU,
            testVectors: [
                { inputs: { A: false, B: false }, expected: false },
                { inputs: { A: true,  B: false }, expected: false },
                { inputs: { A: false, B: true  }, expected: false },
                { inputs: { A: true,  B: true  }, expected: true }
            ],
            hint: "Conecte as saídas das Chaves A e B nas entradas de uma porta lógica AND (7408) e a saída S no borne A1 do Solenoide Y1.",
            feedbackOk: "Circuito pneumático testado e aprovado! Atendimento pleno à norma de comando bimanual."
        },
        {
            title: "02. Intertravamento com Relé e Sensor S1",
            desc: "Conecte a saída do sensor de fim de curso S1 do cilindro à bobina do Relé para cortar o sinal de avanço ou sinalizar o fim de curso.",
            type: 'quiz',
            options: [
                "O sensor S1 emite nível alto quando o cilindro atinge o avanço pleno (≥ 96%).",
                "O sensor S1 emite nível alto apenas com o cilindro completamente recuado.",
                "O sensor S1 só funciona com portas lógicas inversoras NOT.",
                "O sensor S1 deve ser ligado diretamente à pressão de alimentação 1(P)."
            ],
            answer: 0,
            hint: "S0 detecta o recuo traseiro e S1 detecta a posição de avanço frontal da haste.",
            feedbackOk: "Correto! O sensor magnético S1 comuta para HIGH em 24VDC ao detectar o êmbolo no fim do curso de avanço.",
            feedbackFail: "Incorreto. Lembre-se: S0 = Recuado e S1 = Avançado."
        }
    ];

    const HYDRA_CHALLENGES = [
        {
            title: "01. Acionamento Hidráulico Alternativo",
            desc: "Monte na bancada um circuito para o cilindro hidráulico avançar quando a Chave A OU a Chave B estiver em HIGH (YH1 = A + B).",
            type: 'testbench',
            switches: ['A', 'B'],
            targetType: core.COMP.SOLENOID_HYDRA,
            testVectors: [
                { inputs: { A: false, B: false }, expected: false },
                { inputs: { A: true,  B: false }, expected: true },
                { inputs: { A: false, B: true  }, expected: true },
                { inputs: { A: true,  B: true  }, expected: true }
            ],
            hint: "Conecte as Chaves A e B na porta OR (7432) e a saída S no borne A1 do Solenoide YH1.",
            feedbackOk: "Circuito eletro-hidráulico testado e validado em todas as combinações de entrada!"
        }
    ];

    function getCurrentChallengeList() {
        if (window.LogicCraft.challenges) {
            return window.LogicCraft.challenges.getChallengesForPhase(challengeCategory);
        }
        if (challengeCategory === 'bcd') return BCD_CHALLENGES;
        if (challengeCategory === 'hydra') return HYDRA_CHALLENGES;
        if (challengeCategory === 'pneu') return PNEU_CHALLENGES;
        if (challengeCategory === 'simplification') return SIMPLIFICATION_CHALLENGES;
        return FUNDAMENTALS_CHALLENGES;
    }

    function renderChallengePanel() {
        const list = getCurrentChallengeList();
        if (!list || list.length === 0) return;
        if (currentChIdx >= list.length) currentChIdx = 0;
        const ch = list[currentChIdx];
        
        const elTitle = document.getElementById('ch-title');
        const elDesc = document.getElementById('ch-desc');
        const elIdx = document.getElementById('ch-index');
        const elQuiz = document.getElementById('ch-interactive-quiz');
        const elProgress = document.getElementById('ch-progress-bar');

        if (elTitle) elTitle.textContent = ch.title;
        const phaseNum = ch.phase || parseInt(challengeCategory.replace('fase-', '')) || 1;
        if (elIdx) elIdx.textContent = `${phaseNum}/10`;
        if (elProgress) elProgress.style.width = `${(phaseNum / 10) * 100}%`;

        if (elDesc) {
            elDesc.replaceChildren();
            if (ch.objective) {
                // phaseNum already defined above.

                const badge = (window.LogicCraftGuard?.createSafeElement)
                    ? window.LogicCraftGuard.createSafeElement('div', `ch-phase-badge phase-${phaseNum}`, `Fase ${phaseNum}`)
                    : document.createElement('div');
                if (!window.LogicCraftGuard?.createSafeElement) {
                    badge.className = `ch-phase-badge phase-${phaseNum}`;
                    badge.textContent = `Fase ${phaseNum}`;
                }
                elDesc.appendChild(badge);

                // Objetivo em destaque claro e direto
                const objBox = document.createElement('div');
                objBox.style.cssText = 'background:rgba(22, 119, 242, 0.12); border-left:3px solid #38BDF8; padding:8px 10px; border-radius:4px; margin:6px 0;';
                const objTitle = document.createElement('div');
                objTitle.style.cssText = 'font-size:11px; font-weight:700; color:#38BDF8; text-transform:uppercase; margin-bottom:3px;';
                objTitle.textContent = '🎯 Objetivo';
                const objText = document.createElement('div');
                objText.style.cssText = 'font-size:12px; line-height:1.45; color:var(--lc-white); font-weight:500;';
                objText.textContent = ch.objective;
                objBox.appendChild(objTitle);
                objBox.appendChild(objText);
                elDesc.appendChild(objBox);

                // Seção expansível: Como montar
                if (ch.steps && ch.steps.length > 0) {
                    const detSteps = document.createElement('details');
                    detSteps.className = 'ch-details';
                    detSteps.open = true;
                    const sumSteps = document.createElement('summary');
                    sumSteps.textContent = '🛠️ Como montar';
                    detSteps.appendChild(sumSteps);

                    const contentSteps = document.createElement('div');
                    contentSteps.className = 'ch-details-content';
                    ch.steps.forEach(s => {
                        const stepDiv = document.createElement('div');
                        stepDiv.className = 'ch-guide-step';
                        stepDiv.textContent = s;
                        contentSteps.appendChild(stepDiv);
                    });
                    detSteps.appendChild(contentSteps);
                    elDesc.appendChild(detSteps);
                }

                // Seção expansível: Entenda a lógica
                if (ch.theory) {
                    const detTheory = document.createElement('details');
                    detTheory.className = 'ch-details';
                    const sumTheory = document.createElement('summary');
                    sumTheory.textContent = '📖 Entenda a lógica';
                    detTheory.appendChild(sumTheory);

                    const contentTheory = document.createElement('div');
                    contentTheory.className = 'ch-details-content';
                    contentTheory.textContent = ch.theory;
                    detTheory.appendChild(contentTheory);
                    elDesc.appendChild(detTheory);
                }

                // Seção expansível: Dica
                if (ch.hint) {
                    const detHint = document.createElement('details');
                    detHint.className = 'ch-details';
                    const sumHint = document.createElement('summary');
                    sumHint.textContent = '💡 Dica';
                    detHint.appendChild(sumHint);

                    const contentHint = document.createElement('div');
                    contentHint.className = 'ch-details-content';
                    contentHint.style.color = '#FDE68A';
                    contentHint.textContent = ch.hint;
                    detHint.appendChild(contentHint);
                    elDesc.appendChild(detHint);
                }
            } else {
                elDesc.textContent = ch.desc || '';
            }
        }

        if (elQuiz) {
            elQuiz.replaceChildren();
            if (ch.quiz) {
                elQuiz.style.display = 'block';
                const qTitle = document.createElement('div');
                qTitle.style.cssText = 'font-weight:600; font-size:12px; color:var(--lc-white); margin-bottom:6px;';
                qTitle.textContent = ch.quiz.question;
                elQuiz.appendChild(qTitle);

                ch.quiz.options.forEach((opt, i) => {
                    const btn = document.createElement('button');
                    btn.className = `quiz-option ${selectedQuizOption === i ? 'selected' : ''}`;
                    btn.dataset.idx = String(i);
                    btn.textContent = opt;
                    btn.addEventListener('click', () => {
                        selectedQuizOption = i;
                        renderChallengePanel();
                    });
                    elQuiz.appendChild(btn);
                });
            } else if (ch.type === 'quiz') {
                elQuiz.style.display = 'block';
                ch.options.forEach((opt, i) => {
                    const btn = document.createElement('button');
                    btn.className = `quiz-option ${selectedQuizOption === i ? 'selected' : ''}`;
                    btn.dataset.idx = String(i);
                    btn.textContent = opt;
                    btn.addEventListener('click', () => {
                        selectedQuizOption = i;
                        renderChallengePanel();
                    });
                    elQuiz.appendChild(btn);
                });
            } else {
                elQuiz.style.display = 'none';
                selectedQuizOption = null;
            }
        }
    }

    function validateCurrentChallenge() {
        const list = getCurrentChallengeList();
        const ch = list[currentChIdx];
        if (!ch) return;

        let circuitOkMsg = '';

        // 1. Validação física do circuito na bancada (Hardware)
        if (ch.verifyCircuit) {
            const res = ch.verifyCircuit(state.circuit, state.airWires, state.hoses || []);
            if (!res.ok) {
                showToast('error', res.msg);
                return;
            }
            circuitOkMsg = res.msg;
        }

        // 2. Validação pedagógica do questionário (se presente no desafio)
        if (ch.quiz) {
            if (selectedQuizOption === null) {
                showToast('warning', circuitOkMsg 
                    ? `${circuitOkMsg} Agora selecione a alternativa correta na pergunta abaixo para concluir a fase.`
                    : 'Selecione uma alternativa na pergunta antes de concluir.');
                return;
            }
            if (selectedQuizOption !== ch.quiz.correct) {
                showToast('error', 'Montagem correta, mas a alternativa selecionada na pergunta está incorreta. Revise os conceitos e tente novamente.');
                return;
            }
        }

        // 3. Validação de desafios especiais (word / quiz puro)
        if (ch.type === 'word') {
            const currentWord = core.getDigitalWordState().binary;
            if (currentWord !== ch.expected) {
                showToast('error', `Palavra atual: ${currentWord}₂. Esperado pelo desafio: ${ch.expected}₂.`);
                return;
            }
        }

        if (ch.type === 'quiz') {
            if (selectedQuizOption === null) {
                showToast('warning', 'Selecione uma alternativa antes de testar.');
                return;
            }
            if (selectedQuizOption !== ch.answer) {
                showToast('error', ch.feedbackFail || 'Resposta incorreta.');
                return;
            }
        }

        // 4. Conclusão da fase com comemoração sonora e desbloqueio da próxima etapa
        markPhaseCompleted(challengeCategory);

        if (window.LogicCraft?.audio?.playSuccessChime) {
            window.LogicCraft.audio.playSuccessChime();
        }

        const currentIdx = PHASES_ORDER.indexOf(challengeCategory);
        const isLastPhase = currentIdx === PHASES_ORDER.length - 1;
        const nextPhaseCat = !isLastPhase ? PHASES_ORDER[currentIdx + 1] : null;

        const baseMsg = ch.feedbackOk || (circuitOkMsg ? `${circuitOkMsg} Questionário respondido corretamente!` : 'Desafio concluído com sucesso!');
        const celebrationMsg = isLastPhase
            ? `🏆 PARABÉNS! Você concluiu todas as 10 fases da campanha didática!`
            : `${baseMsg} 🎉 Fase ${currentIdx + 1} Concluída! Desbloqueando Fase ${currentIdx + 2}...`;

        showToast('success', celebrationMsg);

        if (nextPhaseCat) {
            setTimeout(() => {
                challengeCategory = nextPhaseCat;
                currentChIdx = 0;
                selectedQuizOption = null;
                document.querySelectorAll('.btn-cat').forEach(b => b.classList.remove('active'));
                const nextBtn = document.getElementById('btn-cat-' + nextPhaseCat);
                if (nextBtn) nextBtn.classList.add('active');
                renderChallengePanel();
                showToast('info', `▶️ Iniciando Fase ${currentIdx + 2}! Boa sorte!`);
            }, 1200);
        }
    }

    function getFocusedNode() {
        if (state.currentOpenModalType && state.modalLockedNodeKey) {
            const locked = state.circuit.get(state.modalLockedNodeKey);
            if (locked) return locked;
        }
        if (state.lockedInspectionNodeKey) {
            const locked = state.circuit.get(state.lockedInspectionNodeKey);
            if (locked) return locked;
        }
        if (!state.focusedNodeKey) return null;
        return state.circuit.get(state.focusedNodeKey);
    }

    function closeAllModals() {
        const bg = document.getElementById('modal-screen');
        if (bg) bg.classList.remove('open');
        state.currentOpenModalType = null;
        state.modalLockedNodeKey = null;
        state.lockedInspectionNodeKey = null;
    }

    function openModal(type) {
        state.currentOpenModalType = type;
        if (type === 'karnaugh' || type === 'truth-table' || type === 'fundamentals') {
            state.modalLockedNodeKey = state.lockedInspectionNodeKey || state.focusedNodeKey;
        }
        const bg = document.getElementById('modal-screen');
        if (bg) bg.classList.add('open');
    }

    function renderFundamentalsModal() {
        const elTitle = document.getElementById('modal-title');
        const elBody = document.getElementById('modal-body');
        if (!elTitle || !elBody) return;

        const node = getFocusedNode();

        const sealInDiagramHtml = `
            <div style="background:#070F1E; border:1px solid var(--lc-slate-700); border-radius:8px; padding:12px; margin-top:10px;">
                <div style="font-weight:700; color:#38BDF8; font-size:12px; margin-bottom:8px;">ESQUEMA PRÁTICO: CIRCUITO DE AUTORRETENÇÃO (SELO)</div>
                <svg viewBox="0 0 540 160" style="width:100%; max-height:160px; display:block; font-family:monospace;">
                    <line x1="20" y1="20" x2="520" y2="20" stroke="#EF4444" stroke-width="2.5"/>
                    <text x="25" y="15" fill="#EF4444" font-size="10" font-weight="bold">+24VDC</text>
                    <line x1="20" y1="140" x2="520" y2="140" stroke="#0284C7" stroke-width="2.5"/>
                    <text x="25" y="155" fill="#38BDF8" font-size="10" font-weight="bold">0V / COMUM</text>
                    
                    <line x1="70" y1="20" x2="70" y2="40" stroke="#CBD5E1" stroke-width="2"/>
                    <rect x="52" y="40" width="36" height="24" rx="3" fill="#1E293B" stroke="#EF4444" stroke-width="1.5"/>
                    <line x1="60" y1="48" x2="80" y2="48" stroke="#EF4444" stroke-width="2"/>
                    <line x1="70" y1="48" x2="70" y2="40" stroke="#EF4444" stroke-width="1.5"/>
                    <line x1="70" y1="48" x2="70" y2="64" stroke="#EF4444" stroke-width="1.5"/>
                    <text x="96" y="55" fill="#F8FAFC" font-size="9" font-weight="bold">S0 (NF 11/12) - PARADA</text>
                    
                    <line x1="70" y1="64" x2="70" y2="75" stroke="#CBD5E1" stroke-width="2"/>
                    <circle cx="70" cy="75" r="3" fill="#F59E0B"/>
                    <line x1="70" y1="75" x2="160" y2="75" stroke="#CBD5E1" stroke-width="2"/>
                    <line x1="70" y1="75" x2="70" y2="90" stroke="#CBD5E1" stroke-width="2"/>
                    <line x1="160" y1="75" x2="160" y2="90" stroke="#CBD5E1" stroke-width="2"/>
                    
                    <rect x="52" y="90" width="36" height="22" rx="3" fill="#1E293B" stroke="#22C55E" stroke-width="1.5"/>
                    <line x1="60" y1="106" x2="80" y2="96" stroke="#22C55E" stroke-width="2"/>
                    <line x1="70" y1="90" x2="70" y2="96" stroke="#22C55E" stroke-width="1.5"/>
                    <line x1="70" y1="106" x2="70" y2="112" stroke="#22C55E" stroke-width="1.5"/>
                    <text x="40" y="125" fill="#22C55E" font-size="8">S1 (NA 13/14)</text>
                    
                    <rect x="142" y="90" width="36" height="22" rx="3" fill="#1E293B" stroke="#38BDF8" stroke-width="1.5"/>
                    <line x1="150" y1="106" x2="170" y2="96" stroke="#38BDF8" stroke-width="2"/>
                    <line x1="160" y1="90" x2="160" y2="96" stroke="#38BDF8" stroke-width="1.5"/>
                    <line x1="160" y1="106" x2="160" y2="112" stroke="#38BDF8" stroke-width="1.5"/>
                    <text x="135" y="125" fill="#38BDF8" font-size="8">K1 (SELO NO)</text>
                    
                    <line x1="70" y1="112" x2="70" y2="120" stroke="#CBD5E1" stroke-width="2"/>
                    <line x1="160" y1="112" x2="160" y2="120" stroke="#CBD5E1" stroke-width="2"/>
                    <line x1="70" y1="120" x2="160" y2="120" stroke="#CBD5E1" stroke-width="2"/>
                    <circle cx="115" cy="120" r="3" fill="#F59E0B"/>
                    
                    <line x1="115" y1="120" x2="280" y2="120" stroke="#CBD5E1" stroke-width="2"/>
                    <line x1="280" y1="120" x2="280" y2="60" stroke="#CBD5E1" stroke-width="2"/>
                    
                    <rect x="256" y="60" width="48" height="32" rx="4" fill="#0F172A" stroke="#F59E0B" stroke-width="2"/>
                    <text x="280" y="80" fill="#F59E0B" font-size="11" font-weight="bold" text-anchor="middle">K1</text>
                    <text x="250" y="55" fill="#94A3B8" font-size="8">A1</text>
                    <text x="310" y="105" fill="#94A3B8" font-size="8">A2</text>
                    
                    <line x1="280" y1="92" x2="280" y2="140" stroke="#CBD5E1" stroke-width="2"/>
                    <circle cx="280" cy="140" r="3" fill="#0284C7"/>
                    
                    <line x1="380" y1="20" x2="380" y2="60" stroke="#CBD5E1" stroke-width="2"/>
                    <rect x="360" y="60" width="40" height="24" rx="3" fill="#1E293B" stroke="#38BDF8" stroke-width="1.5"/>
                    <text x="380" y="76" fill="#38BDF8" font-size="9" font-weight="bold" text-anchor="middle">K1-NO</text>
                    <line x1="380" y1="84" x2="380" y2="100" stroke="#CBD5E1" stroke-width="2"/>
                    <rect x="360" y="100" width="40" height="26" rx="3" fill="#0F172A" stroke="#22C55E" stroke-width="1.8"/>
                    <text x="380" y="117" fill="#22C55E" font-size="9" font-weight="bold" text-anchor="middle">SOL 1Y1</text>
                    <line x1="380" y1="126" x2="380" y2="140" stroke="#CBD5E1" stroke-width="2"/>
                    <circle cx="380" cy="140" r="3" fill="#0284C7"/>
                </svg>
                <div style="font-size:11.5px; color:var(--lc-slate-300); margin-top:8px; line-height:1.5;">
                    <b>Lógica Operacional do Selo:</b> Ao acionar a botoeira <b>Partida NA (13/14)</b>, a corrente atinge a bobina <b>A1</b> do relé <b>K1</b>. O contato auxiliar <b>K1 (13/14)</b> fecha em paralelo com a botoeira. Ao soltar a botoeira, a corrente continua passando pelo contato selado, mantendo a bobina energizada. O rearme só cessa ao abrir o contato <b>NF (11/12)</b> da botoeira de Parada.
                </div>
            </div>
        `;

        const valveDiagramHtml = `
            <div style="background:#070F1E; border:1px solid var(--lc-slate-700); border-radius:8px; padding:12px; margin-top:10px;">
                <div style="font-weight:700; color:#F59E0B; font-size:12px; margin-bottom:8px;">CORTE ESQUEMÁTICO & COMUTAÇÃO (VÁLVULA 5/2 MONOESTÁVEL ISO 1219)</div>
                <svg viewBox="0 0 540 140" style="width:100%; max-height:140px; display:block; font-family:monospace;">
                    <g transform="translate(10, 10)">
                        <rect x="0" y="0" width="245" height="110" rx="6" fill="#111827" stroke="#334155" stroke-width="1.5"/>
                        <text x="122" y="16" fill="#94A3B8" font-size="9" font-weight="bold" text-anchor="middle">REPOUSO (RETORNO POR MOLA)</text>
                        <rect x="15" y="42" width="215" height="34" rx="3" fill="#1E293B" stroke="#475569" stroke-width="1"/>
                        <rect x="25" y="45" width="28" height="28" fill="#64748B"/>
                        <rect x="75" y="45" width="28" height="28" fill="#64748B"/>
                        <rect x="125" y="45" width="28" height="28" fill="#64748B"/>
                        <path d="M190 48 Q195 62 200 48 T210 48 T220 48" stroke="#F59E0B" stroke-width="2.5" fill="none"/>
                        <text x="205" y="90" fill="#F59E0B" font-size="8" text-anchor="middle">Mola</text>
                        <text x="40" y="100" fill="#94A3B8" font-size="9">5(S)</text>
                        <text x="85" y="100" fill="#00E5FF" font-size="9" font-weight="bold">1(P)</text>
                        <text x="130" y="100" fill="#94A3B8" font-size="9">3(R)</text>
                        <text x="60" y="34" fill="#94A3B8" font-size="9">4(A)</text>
                        <text x="110" y="34" fill="#00E5FF" font-size="9" font-weight="bold">2(B)</text>
                        <path d="M89 90 L89 74 Q89 59 114 59 L114 38" stroke="#00E5FF" stroke-width="2" fill="none"/>
                        <path d="M64 38 L64 59 Q64 74 44 74 L44 90" stroke="#64748B" stroke-width="1.5" stroke-dasharray="2 2" fill="none"/>
                    </g>
                    <g transform="translate(285, 10)">
                        <rect x="0" y="0" width="245" height="110" rx="6" fill="#111827" stroke="#0EA5E9" stroke-width="1.5"/>
                        <text x="122" y="16" fill="#38BDF8" font-size="9" font-weight="bold" text-anchor="middle">PILOTADA (SOLENOIDE Y1 ENERGIZADO)</text>
                        <rect x="8" y="38" width="22" height="42" rx="2" fill="#0EA5E9" opacity="0.85"/>
                        <text x="19" y="63" fill="#0F172A" font-size="8" font-weight="bold" text-anchor="middle">Y1</text>
                        <rect x="35" y="42" width="200" height="34" rx="3" fill="#1E293B" stroke="#475569" stroke-width="1"/>
                        <rect x="55" y="45" width="28" height="28" fill="#64748B"/>
                        <rect x="105" y="45" width="28" height="28" fill="#64748B"/>
                        <rect x="155" y="45" width="28" height="28" fill="#64748B"/>
                        <path d="M210 48 Q213 62 216 48 T222 48" stroke="#F59E0B" stroke-width="3" fill="none"/>
                        <text x="50" y="100" fill="#94A3B8" font-size="9">5(S)</text>
                        <text x="95" y="100" fill="#00E5FF" font-size="9" font-weight="bold">1(P)</text>
                        <text x="140" y="100" fill="#94A3B8" font-size="9">3(R)</text>
                        <text x="70" y="34" fill="#00E5FF" font-size="9" font-weight="bold">4(A)</text>
                        <text x="120" y="34" fill="#94A3B8" font-size="9">2(B)</text>
                        <path d="M99 90 L99 74 Q99 59 74 59 L74 38" stroke="#00E5FF" stroke-width="2" fill="none"/>
                        <path d="M124 38 L124 59 Q124 74 144 74 L144 90" stroke="#64748B" stroke-width="1.5" stroke-dasharray="2 2" fill="none"/>
                    </g>
                </svg>
                <div style="font-size:11.5px; color:var(--lc-slate-300); margin-top:8px; line-height:1.5;">
                    <b>Funcionamento Físico:</b> Em repouso, a mola interna mantém a pressão 1(P) comunicando com o pórtico 2(B) (retração). Ao energizar a bobina do solenoide <b>Y1</b>, o campo magnético vence a força da mola, deslocando o carretel e direcionando a pressão para 4(A) (avanço), enquanto 2(B) despressuriza pelo escape 3(R).
                </div>
            </div>
        `;

        const actuatorDynamicsHtml = `
            <div style="background:#070F1E; border:1px solid var(--lc-slate-700); border-radius:8px; padding:12px; margin-top:10px;">
                <div style="font-weight:700; color:#22C55E; font-size:12px; margin-bottom:8px;">ATUADORES FLUÍDICOS, SENSORES MAGNÉTICOS S0/S1 & DINÂMICA DE PRESSÃO</div>
                <div style="display:grid; grid-template-columns: 1fr 1fr; gap:12px; font-size:12px; line-height:1.5;">
                    <div style="background:rgba(2, 132, 199, 0.08); border:1px solid rgba(2, 132, 199, 0.3); border-radius:6px; padding:10px;">
                        <div style="font-weight:bold; color:#00E5FF; margin-bottom:4px;">Pneumática Industrial (6,0 bar / 0,6 MPa)</div>
                        <p style="margin:0 0 6px 0; color:var(--lc-slate-300);">
                            • <b>Fluido Compressível:</b> O ar comprimido absorve impactos, permitindo altas taxas de aceleração e velocidades entre 0,5 e 1,5 m/s.
                        </p>
                        <p style="margin:0 0 6px 0; color:var(--lc-slate-300);">
                            • <b>Força Dinâmica:</b> Proporcional à pressão manométrica calibrada na unidade FRL: $F = P \\cdot A$.
                        </p>
                        <p style="margin:0; color:var(--lc-slate-300);">
                            • <b>Escape Atmosférico:</b> O fluido despressurizado escapa diretamente ao ambiente através dos silenciadores de bronze sinterizado 3(R) e 5(S).
                        </p>
                    </div>
                    <div style="background:rgba(217, 119, 6, 0.08); border:1px solid rgba(217, 119, 6, 0.3); border-radius:6px; padding:10px;">
                        <div style="font-weight:bold; color:#F59E0B; margin-bottom:4px;">Hidráulica de Potência (120 bar / 12 MPa)</div>
                        <p style="margin:0 0 6px 0; color:var(--lc-slate-300);">
                            • <b>Fluido Incompressível:</b> O óleo ISO VG 46 confere rigidez posicional absoluta, suportando cargas extremas sem efeito chicote (*stick-slip*).
                        </p>
                        <p style="margin:0 0 6px 0; color:var(--lc-slate-300);">
                            • <b>Velocidade Controlada:</b> Rigidamente definida pela vazão volumétrica da bomba HPU e reguladora de fluxo ($Q = v \\cdot A$).
                        </p>
                        <p style="margin:0; color:var(--lc-slate-300);">
                            • <b>Retorno Obrigatório ao Tanque (T):</b> Circuito fechado mandatório. Se a linha de retorno ao tanque estiver desconectada, a válvula bloqueia imediatamente por sobrepressão.
                        </p>
                    </div>
                </div>
                <div style="background:rgba(34, 197, 94, 0.06); border:1px solid rgba(34, 197, 94, 0.25); border-radius:6px; padding:10px; margin-top:10px; font-size:12px; color:var(--lc-slate-200);">
                    <b>Sensores Magnéticos em Presilha (SMC / Festo):</b> Os sensores <b>S0</b> (recuo / 0%) e <b>S1</b> (avanço / 100%) são acoplados às ranhuras do corpo do cilindro. Quando o anel magnético integrado ao êmbolo se alinha com o sensor, o contato fecha, emitindo 24VDC no borne de saída e acendendo o LED piloto.
                </div>
            </div>
        `;

        function formatIndustrialTheoryCard({ title, subtitle, color = 'var(--lc-blue-400)', what, how, pinout, apps, telemetryHtml = '' }) {
            return `
                <div class="diag-card" style="border-left: 4px solid ${color};">
                    <div class="diag-card-title" style="color: ${color}; font-size: 14.5px; display: flex; align-items: center; justify-content: space-between; flex-wrap: wrap; gap: 6px;">
                        <span>${title}</span>
                        ${subtitle ? `<span style="font-size: 11px; font-weight: normal; color: var(--lc-slate-300);">${subtitle}</span>` : ''}
                    </div>
                    ${telemetryHtml ? `<div style="background: rgba(15, 23, 42, 0.7); border: 1px solid var(--lc-slate-700); border-radius: 6px; padding: 10px; margin: 10px 0; font-size: 12.5px; line-height: 1.5;">${telemetryHtml}</div>` : ''}
                    <div class="theory-didactic-body" style="display: flex; flex-direction: column; gap: 10px; margin-top: 12px; font-size: 13px; line-height: 1.55;">
                        <div>
                            <b style="color: var(--lc-yellow-400); display: block; font-size: 11.5px; text-transform: uppercase; letter-spacing: 0.05em; margin-bottom: 3px;">1. O que é</b>
                            <div style="color: var(--lc-slate-200);">${what}</div>
                        </div>
                        <div>
                            <b style="color: var(--lc-yellow-400); display: block; font-size: 11.5px; text-transform: uppercase; letter-spacing: 0.05em; margin-bottom: 3px;">2. Como funciona</b>
                            <div style="color: var(--lc-slate-200);">${how}</div>
                        </div>
                        <div>
                            <b style="color: var(--lc-yellow-400); display: block; font-size: 11.5px; text-transform: uppercase; letter-spacing: 0.05em; margin-bottom: 3px;">3. Terminais e conexões</b>
                            <div style="color: var(--lc-slate-200);">${pinout}</div>
                        </div>
                        <div>
                            <b style="color: var(--lc-yellow-400); display: block; font-size: 11.5px; text-transform: uppercase; letter-spacing: 0.05em; margin-bottom: 3px;">4. Onde é usado</b>
                            <div style="color: var(--lc-slate-200);">${apps}</div>
                        </div>
                        <div style="font-size: 11px; color: var(--lc-slate-400); margin-top: 10px; border-top: 1px solid rgba(255,255,255,0.08); padding-top: 6px; font-style: italic;">
                            * Modelo didático para aprendizagem. A aprovação no simulador tem fins educativos e não certifica uma instalação real.
                        </div>
                    </div>
                </div>
            `;
        }

        const advancedDiagHtml = `
            <div style="background:#070F1E; border:1px solid var(--lc-slate-700); border-radius:8px; padding:12px; margin-top:10px;">
                <div style="font-weight:700; color:#F59E0B; font-size:12px; margin-bottom:8px;">DIAGNÓSTICO AVANÇADO E SEGURANÇA NR-12</div>
                
                <div style="margin-bottom:12px;">
                    <div style="color:#38BDF8; font-size:11px; font-weight:bold; margin-bottom:4px;">1. DIAGRAMA DE BLOCOS: TIMEOUT (FALHA DE ATUADOR)</div>
                    <div style="color:var(--lc-slate-300); font-size:11px; line-height:1.4;">
                        A detecção de haste travada (perda de pressão ou bloqueio mecânico) utiliza um Temporizador On-Delay (TON).<br>
                        O comando de avanço da válvula inicia a contagem de tempo (PT = 2.0s). Se o sensor S1 não for alcançado (S1=0), a saída Q do timer soará o alarme.<br>
                        <b>Lógica Booleana:</b> <code style="color:#EF4444; background:#1E293B; padding:2px 4px; border-radius:3px;">Alarme = Q(TON) · NOT(S1)</code>
                    </div>
                </div>

                <div style="margin-bottom:12px;">
                    <div style="color:#38BDF8; font-size:11px; font-weight:bold; margin-bottom:4px;">2. INTERTRAVAMENTO NR-12 E HOMING</div>
                    <div style="color:var(--lc-slate-300); font-size:11px; line-height:1.4;">
                        <b>Parada de Emergência (Prioridade Absoluta):</b> O cogumelo corta instantaneamente o nível de comando dos atuadores.<br>
                        <b>Homing (Posição Zero):</b> A máquina é travada para evitar partida fora da posição segura inicial.<br>
                        <b>Lógica de Partida:</b> <code style="color:#22C55E; background:#1E293B; padding:2px 4px; border-radius:3px;">Autorização = Botão Partida · S0 · Emergência_OK</code>
                    </div>
                </div>

                <div>
                    <div style="color:#38BDF8; font-size:11px; font-weight:bold; margin-bottom:4px;">3. CÓDIGOS BCD DE ALARME PARA IHM (DISPLAY 7 SEG)</div>
                    <table style="width:100%; text-align:left; border-collapse:collapse; font-size:11px; color:var(--lc-slate-300); border:1px solid var(--lc-slate-700);">
                        <tr style="background:#1E293B; color:#F8FAFC; font-weight:bold;">
                            <th style="padding:4px; border:1px solid var(--lc-slate-700);">Palavra BCD (DCBA)</th>
                            <th style="padding:4px; border:1px solid var(--lc-slate-700);">Dígito</th>
                            <th style="padding:4px; border:1px solid var(--lc-slate-700);">Diagnóstico de Falha</th>
                        </tr>
                        <tr><td style="padding:4px; border:1px solid var(--lc-slate-700);">0000</td><td style="padding:4px; border:1px solid var(--lc-slate-700); font-weight:bold; color:var(--lc-success);">0</td><td style="padding:4px; border:1px solid var(--lc-slate-700);">Sistema Pronto (Operação Normal)</td></tr>
                        <tr><td style="padding:4px; border:1px solid var(--lc-slate-700);">0001</td><td style="padding:4px; border:1px solid var(--lc-slate-700); font-weight:bold; color:#F59E0B;">1</td><td style="padding:4px; border:1px solid var(--lc-slate-700);">Falha 1: Sobrecarga / Sem Pressão FRL</td></tr>
                        <tr><td style="padding:4px; border:1px solid var(--lc-slate-700);">0010</td><td style="padding:4px; border:1px solid var(--lc-slate-700); font-weight:bold; color:#EF4444;">2</td><td style="padding:4px; border:1px solid var(--lc-slate-700);">Falha 2: Emergência NR-12 Atuada</td></tr>
                        <tr><td style="padding:4px; border:1px solid var(--lc-slate-700);">0011</td><td style="padding:4px; border:1px solid var(--lc-slate-700); font-weight:bold; color:#EF4444;">3</td><td style="padding:4px; border:1px solid var(--lc-slate-700);">Falha 3: Timeout Haste Travada (TON > PT)</td></tr>
                    </table>
                </div>
            </div>
        `;

        if (!node) {
            elTitle.textContent = 'Fundamentos dos Sistemas Digitais, Eletropneumáticos e Hidráulicos';
            const word = core.getDigitalWordState();
            elBody.innerHTML = `
                <div class="metric-label">Palavra Atual no Barramento de Entrada (Chaves A, B, C, D)</div>
                <div class="metrics-grid">
                    <div class="metric-card"><div class="metric-label">Binário (Nibble)</div><div class="metric-val">${word.binary}₂</div></div>
                    <div class="metric-card"><div class="metric-label">Decimal</div><div class="metric-val">${word.decimal}₁₀</div></div>
                    <div class="metric-card"><div class="metric-label">Hexadecimal</div><div class="metric-val">${word.hexadecimal}₁₆</div></div>
                </div>
                <div class="diag-card" style="margin-top:12px; border-left: 4px solid var(--lc-blue-500);">
                    <div class="diag-card-title" style="color:var(--lc-blue-400);">Visão Geral dos Subsistemas Industriais (Guia Didático do Professor)</div>
                    <p style="margin:6px 0; color:var(--lc-slate-200); font-size:13px; line-height:1.55;">
                        Esta bancada didática integra três disciplinas fundamentais da automação fabril: <b>Eletrônica Digital Combinacional (Portas 74xx e Decodificadores BCD)</b>, <b>Comandos Elétricos e Relés com Intertravamento de Segurança (NR-12)</b> e <b>Sistemas Fluídicos de Potência (Eletropneumática 6 bar e Eletro-hidráulica 120 bar)</b>.
                    </p>
                    <p style="margin:6px 0; color:var(--lc-yellow-400); font-size:12.5px;">
                        <i>💡 Dica Pedagógica: Aponte a mira para qualquer componente na bancada ou clique sobre ele para inspecionar sua fundamentação teórica completa, identificação de bornes, dinâmica física e aplicações práticas.</i>
                    </p>
                </div>
                <div style="background:#070F1E; border:1px solid var(--lc-slate-700); border-radius:8px; padding:12px; margin-top:10px;">
                    <div style="font-weight:700; color:#A78BFA; font-size:12px; margin-bottom:8px;">TIPOS DE ACIONAMENTO INDUSTRIAL</div>
                    <div style="display:grid; grid-template-columns: 1fr 1fr; gap:12px; font-size:11px; line-height:1.4;">
                        <div style="background:rgba(167, 139, 250, 0.08); border:1px solid rgba(167, 139, 250, 0.3); border-radius:6px; padding:10px;">
                            <div style="font-weight:bold; color:#C084FC; margin-bottom:4px;">Acionamento Eletrônico (Estado Sólido)</div>
                            <p style="margin:0 0 6px 0; color:var(--lc-slate-300);">
                                • <b>Física de Comutação:</b> Utiliza semicondutores (transistores em CIs 74xx, decodificadores BCD) para comutar sinais lógicos digitais (5V a 24V DC).<br>
                                • <b>Vantagens:</b> Processamento combinacional ultra-rápido (microssegundos), ausência total de partes móveis, alta durabilidade e imunidade a desgastes mecânicos.<br>
                                • <b>Aplicação:</b> Camada de controle, intertravamento booleano rápido, displays numéricos, processamento de falhas e timeout antes da fase de potência.
                            </p>
                        </div>
                        <div style="background:rgba(234, 88, 12, 0.08); border:1px solid rgba(234, 88, 12, 0.3); border-radius:6px; padding:10px;">
                            <div style="font-weight:bold; color:#FB923C; margin-bottom:4px;">Acionamento Eletromecânico</div>
                            <p style="margin:0 0 6px 0; color:var(--lc-slate-300);">
                                • <b>Física de Comutação:</b> Uma bobina indutiva gera um campo magnético que atraca fisicamente contatos metálicos móveis (Módulo Relé, Contator).<br>
                                • <b>Vantagens:</b> Isolação galvânica física absoluta entre o comando (24VDC) e a potência (220VAC). Pode manobrar correntes altíssimas para ligar motores ou aquecedores.<br>
                                • <b>Aplicação:</b> Estágio final de potência. Quando a lógica de estado sólido "autoriza", o relé atraca para rodar um motor trifásico pesado.
                            </p>
                        </div>
                    </div>
                </div>
                ${sealInDiagramHtml}
                ${valveDiagramHtml}
                ${actuatorDynamicsHtml}
                ${advancedDiagHtml}
            `;
            return;
        }

        if (node.type === core.COMP.DEC_BCD_7SEG) {
            elTitle.textContent = 'Como funciona — Decodificador BCD para 7 Segmentos';
            elBody.innerHTML = formatIndustrialTheoryCard({
                title: 'Decodificador BCD para Display de 7 Segmentos (Padrão 7447)',
                subtitle: 'CI Combinacional Conversor de Código',
                color: '#38BDF8',
                telemetryHtml: `
                    <div>• <b>Palavra BCD de Entrada (A B C D):</b> <b style="color:var(--lc-yellow-400); font-family:monospace;">${core.getDigitalWordState().binary}</b> (Decimal: ${core.getDigitalWordState().decimal})</div>
                    <div>• <b>Segmentos Habilitados:</b> a, b, c, d, e, f, g acionados conforme mintermos decodificados.</div>
                `,
                what: 'Circuito integrado combinacional dedicado à conversão de dados digitais. Ele recebe uma palavra binária de 4 bits em código BCD (A=8, B=4, C=2, D=1, cobrindo os algarismos de 0 a 9) e decodifica essa informação nos 7 sinais lógicos independentes (a até g) necessários para acender os segmentos do mostrador numérico.',
                how: 'Internamente, uma matriz de portas lógicas inversoras, ANDs e ORs sintetiza as equações booleanas mínimas de cada segmento do display. Por exemplo, para desenhar o algarismo 0, o circuito polariza os segmentos a, b, c, d, e, f e mantém o g desenergizado. Para valores de entrada entre 10 e 15 (1010₂ a 1111₂), o decodificador entra em modo de supressão (blanking) ou exibe caracteres especiais fora do padrão decimal.',
                pinout: '<b>Entradas Lógicas:</b> A (Bit 3 / Peso 8), B (Bit 2 / Peso 4), C (Bit 1 / Peso 2), D (Bit 0 / Peso 1).<br><b>Saídas:</b> Terminais a, b, c, d, e, f, g interligados aos pinos individuais dos segmentos de LED.',
                apps: 'Painéis indicadores de contagem em esteiras transportadoras, tacômetros de velocidade de motores elétricos, balanças industriais e instrumentos de medição.'
            });
        } else if (node.type === core.COMP.RELAY) {
            elTitle.textContent = 'Teoria & Especificação Técnica — Relé Eletromecânico Industrial';
            elBody.innerHTML = formatIndustrialTheoryCard({
                title: 'Módulo Relé Eletromecânico Industrial (Interface K1)',
                subtitle: 'Chave Eletromagnética de Comando & Isolação Galvânica',
                color: '#22C55E',
                telemetryHtml: `
                    <div>• <b>Estado da Bobina (A1):</b> ${node.state ? '<b style="color:var(--lc-success);">1 (ENERGIZADA / 24VDC)</b>' : '<b style="color:var(--lc-slate-300);">0 (DESENERGIZADA / 0V)</b>'}</div>
                    <div>• <b>Contato NO (13/14):</b> ${node.state ? '<b style="color:var(--lc-success);">FECHADO (Conduzindo)</b>' : 'ABERTO (Isolado)'} | <b>Contato NC (11/12):</b> ${node.state ? 'ABERTO (Isolado)' : '<b style="color:var(--lc-success);">FECHADO (Conduzindo)</b>'}</div>
                `,
                what: 'Dispositivo eletromecânico de comutação acionado por campo magnético. Atua como um isolador e amplificador de sinal, fornecendo isolação galvânica completa entre circuitos de comando lógico de baixa potência (+24VDC ou TTL) e circuitos de potência que alimentam motores, solenoides e atuadores pesados.',
                how: 'Quando a corrente elétrica contínua percorre a bobina de cobre montada nos bornes A1 e Comum, gera-se um fluxo magnético que atrai a armadura móvel metálica contra o esforço de uma mola de retorno. O movimento da armadura transfere a posição dos contatos reversíveis prateados, unindo o comum ao borne NO (Normalmente Aberto) e separando-o do borne NC (Normalmente Fechado). Ao cessar a alimentação de A1, o campo colapsa e a mola restaura imediatamente o estado de repouso.',
                pinout: '<b>Circuito de Excitação:</b> Borne A1 (+24VDC de controle) e Borne Comum 0V.<br><b>Circuito de Carga / Sinal:</b> Borne COM (Polo Comum), Borne NO (Contato Aberto em repouso 13/14) e Borne NC (Contato Fechado em repouso 11/12).',
                apps: 'Circuito clássico de autorretenção (selo de partida/parada), intertravamento elétrico de segurança contra curto-circuito em reversão de motores trifásicos, acionamento piloto de bobinas de válvulas pesadas e isolação de saídas a transistor de CLPs industriais.'
            }) + sealInDiagramHtml;
        } else if (core.BUTTON_TYPES.has(node.type)) {
            if (node.type === core.COMP.PUSH_BUTTON_NO) {
                elTitle.textContent = 'Teoria & Especificação Técnica — Botoeira NA (Partida Verde)';
                elBody.innerHTML = formatIndustrialTheoryCard({
                    title: 'Botoeira Pulsadora Normalmente Aberta (NA / NO 13-14 - Partida Verde)',
                    subtitle: 'Comando Manual com Retorno por Mola (IEC 60204-1)',
                    color: '#22C55E',
                    telemetryHtml: `<div>• <b>Estado Operacional:</b> ${node.state ? '<b style="color:var(--lc-success);">1 (FECHADA / CONDUZINDO 24V)</b>' : '<b style="color:var(--lc-error);">0 (ABERTA / REPOUSO 0V)</b>'}</div>`,
                    what: 'Dispositivo de comando manual momentâneo de ação por pulso, construído em invólucro termoplástico com diâmetro de furação industrial de 22 mm, cabeçote ergonômico verde e bloco de contato Normalmente Aberto (NA/NO).',
                    how: 'Em repouso, uma mola helicoidal mantém as pontes de contato elétrico afastadas dos bornes estáticos (circuito aberto, 0V). Ao ser acionada pelo operador, a haste vence a mola e fecha os terminais 13 e 14, conduzindo +24VDC (nível lógico 1). Na bancada virtual, o clique opera em modo alternado (toggle) para permitir ensaios práticos sem a necessidade de manter o mouse pressionado.',
                    pinout: '<b>Borne 13:</b> Entrada de Linha (+24VDC).<br><b>Borne 14:</b> Saída de Comando enviada para a bobina A1 do relé ou entrada de porta lógica.',
                    apps: 'Pulso de energização e partida de motores elétricos em conjunto com relé de selo, comando de avanço manual de cilindros em modo de calibração mecânica (jogging) e botão de reinício (reset) de ciclo.'
                }) + sealInDiagramHtml;
            } else if (node.type === core.COMP.PUSH_BUTTON_NC) {
                elTitle.textContent = 'Teoria & Especificação Técnica — Botoeira NF (Parada Vermelha)';
                elBody.innerHTML = formatIndustrialTheoryCard({
                    title: 'Botoeira Pulsadora Normalmente Fechada (NF / NC 11-12 - Parada Vermelha)',
                    subtitle: 'Comando Manual de Parada Operacional (IEC 60204-1)',
                    color: '#EF4444',
                    telemetryHtml: `<div>• <b>Estado Operacional:</b> ${node.state ? '<b style="color:var(--lc-success);">1 (FECHADA / CONDUZINDO 24V)</b>' : '<b style="color:var(--lc-error);">0 (ABERTA / INTERROMPIDA 0V)</b>'}</div>`,
                    what: 'Dispositivo de comando manual de desligamento com cabeçote plano vermelho e bloco de contato Normalmente Fechado (NF/NC), destinado à desativação voluntária de processos industriais.',
                    how: 'Baseia-se no conceito fundamental de segurança positiva (fail-safe). Em repouso, a força da mola mantém a ponte de contato de cobre assentada sobre os terminais, conduzindo continuamente +24VDC. Ao ser pressionada pelo operador, a ponte é empurrada para trás, rompendo o circuito e interrompendo a circulação de corrente para a bobina do relé, o que desliga imediatamente a autorretenção.',
                    pinout: '<b>Borne 11:</b> Entrada de Alimentação (+24VDC).<br><b>Borne 12:</b> Saída em série conectada à cadeia de comando da bobina de retenção.',
                    apps: 'Parada normal de motores elétricos, interrupção de ciclo contínuo em centros de usinagem e abertura de linhas de alimentação de esteiras transportadoras.'
                }) + sealInDiagramHtml;
            } else if (node.type === core.COMP.EMERGENCY_STOP) {
                elTitle.textContent = 'Teoria & Especificação Técnica — Cogumelo de Emergência NR-12';
                elBody.innerHTML = formatIndustrialTheoryCard({
                    title: 'Cogumelo de Parada de Emergência com Trava Mecânica (NR-12 / ISO 13850)',
                    subtitle: 'Dispositivo de Segurança Biestável com Abertura Positiva Obrigatória',
                    color: '#DC2626',
                    telemetryHtml: `
                        <div>• <b>Estado dos Contatos:</b> ${node.state ? '<b style="color:var(--lc-success);">1 (HABILITADO / CONDUZINDO)</b>' : '<b style="color:var(--lc-error);">0 (DESARMADO / ABERTO)</b>'}</div>
                        <div>• <b>Mecanismo de Retenção NR-12:</b> ${node.isEmergencyLocked ? '<b style="color:var(--lc-error);">MECANICAMENTE TRAVADO (Gire para destravar)</b>' : '<b style="color:var(--lc-success);">DESTRAVADO / PRONTO PARA OPERAÇÃO</b>'}</div>
                    `,
                    what: 'Atuador mecânico de segurança prioritária e mandatória pelas normas NR-12 e ABNT NBR ISO 13850. Possui cabeçote tipo cogumelo vermelho de 40 mm sobre anel amarelo, mecanismo biestável com retenção mecânica e contatos de abertura positiva forçada.',
                    how: 'Ao sofrer um golpe rápido (soco de emergência), o mecanismo rompe a continuidade elétrica dos contatos NF mesmo se houver microssoldagem por curto prévio. Simultaneamente, uma trava mecânica interna engata e retém o botão na posição afundada, impedindo o religamento do circuito até que o operador realize deliberadamente o movimento de rotação horária (twist-to-release) para o rearme.',
                    pinout: '<b>Contatos de Segurança NF:</b> Terminais 11-12 e 21-22 com ruptura mecânica garantida para integração a relés de segurança de Categoria 4 / PLe.',
                    apps: 'Parada instantânea de risco iminente em prensas excêntricas, guilhotinas hidráulicas, robôs articulados, pontes rolantes e esteiras transportadoras pesadas.'
                }) + sealInDiagramHtml;
            }
        } else if (node.type === core.COMP.TIMER_TON) {
            elTitle.textContent = 'Teoria & Especificação Técnica — Relé Temporizador TON';
            elBody.innerHTML = formatIndustrialTheoryCard({
                title: 'Relé Temporizador com Retardo na Energização (TON — IEC 61131-3)',
                subtitle: 'Temporização Industrial de Alta Precisão',
                color: '#F59E0B',
                telemetryHtml: `
                    <div>• <b>Tempo Programado (PT):</b> <b style="color:var(--lc-yellow-400);">${(node.delayTime || 2.0).toFixed(1)}s</b> | <b>Tempo Decorrido (ET):</b> ${(node.elapsedTime || 0).toFixed(2)}s</div>
                    <div>• <b>Status da Saída Q:</b> ${node.state ? '<b style="color:var(--lc-success);">1 (DISPARADO / ATIVO)</b>' : '<b style="color:var(--lc-slate-300);">0 (AGUARDANDO / CONTANDO)</b>'}</div>
                `,
                what: 'Módulo eletrônico de temporização industrial padronizado pela norma IEC 61131-3, cuja saída digital Q comuta para nível alto somente após transcorrido um intervalo pré-calibrado (PT) a partir do momento em que a entrada IN é mantida continuamente em nível alto.',
                how: 'Quando o sinal de disparo IN sobe para 1 (+24V), o oscilador de quartzo interno inicia a contagem de tempo decorrido (ET). Durante esse período, a saída Q permanece rigorosamente em 0V. Ao atingir o tempo estabelecido (PT), os circuitos de saída comutam para nível lógico 1 (+24V) e mantêm-se energizados. Caso a entrada IN retorne para 0 em qualquer momento antes ou depois da comutação, o temporizador reseta imediatamente, zerando a contagem e desarmando Q.',
                pinout: '<b>Borne IN:</b> Entrada de Habilitação / Disparo.<br><b>Borne PT:</b> Ajuste do Tempo de Retardo.<br><b>Borne Q:</b> Saída Digital Temporizada.<br><b>Borne COM:</b> Referência Comum 0V.',
                apps: 'Partidas comutadas estrela-triângulo em motores de indução (tempo de aceleração antes da transição), acionamento escalonado de esteiras para evitar picos de corrente na subestação e purga temporizada de gases em queimadores industriais.'
            });
        } else if (node.type === core.COMP.VALVE_FLOW_CONTROL) {
            elTitle.textContent = 'Como funciona — Válvula Reguladora de Fluxo';
            elBody.innerHTML = formatIndustrialTheoryCard({
                title: 'Válvula Reguladora de Fluxo Unidirecional (ISO 1219)',
                subtitle: 'Controle de Velocidade Hidropneumático por Estrangulamento de Escape',
                color: '#F59E0B',
                telemetryHtml: `
                    <div>• <b>Abertura do Manípulo:</b> <b style="color:var(--lc-yellow-400);">${node.openingPercent ?? 100}%</b></div>
                    <div style="color:var(--lc-slate-300);">• <i>Dica de Operação: Clique com botão esquerdo sobre o manípulo na bancada para ciclar entre 100%, 75%, 50%, 25%, 10% e 0% (fechada).</i></div>
                `,
                what: 'Válvula de controle de vazão volumétrica montada diretamente nos niples de trabalho das câmaras dos cilindros. É constituída por um carretel de agulha cônica regulável em paralelo com uma válvula de retenção de esfera e mola.',
                how: 'No sentido de regulagem (geralmente regulagem no escape - método meter-out), a pressão do fluido assenta a esfera contra a sede de vedação, impedindo a passagem direta e forçando 100% do fluido a escoar pelo estreito canal calibrado da agulha. Isso gera uma contrapressão controlada que amortece o movimento da haste, eliminando saltos bruscos. No sentido oposto, a pressão afasta a esfera da sede, permitindo fluxo livre sem qualquer restrição.',
                pinout: '<b>Pórtico 1:</b> Entrada de fluido conectada à linha da válvula direcional.<br><b>Pórtico 2:</b> Saída regulada conectada diretamente à câmara de trabalho do cilindro.',
                apps: 'Ajuste fino de velocidade de avanço e recuo de cilindros em linhas de montagem, amortecimento de impactos em fins de curso e velocidade constante em unidades de avanço de usinagem.'
            }) + actuatorDynamicsHtml;
        } else if (core.CYLINDER_TYPES.has(node.type)) {
            const isSingle = node.type === core.COMP.CYL_SINGLE;
            const isHydra = node.type === core.COMP.CYL_HYDRA;
            const cylTitle = isSingle 
                ? 'Cilindro Pneumático de Simples Ação com Retorno por Mola (ISO 15552)'
                : isHydra 
                    ? 'Cilindro Hidráulico de Alta Pressão 120 bar (ISO 6020-2)'
                    : 'Cilindro Pneumático de Dupla Ação com Amortecimento (ISO 15552)';
            const cylColor = isHydra ? '#F59E0B' : '#00E5FF';

            elTitle.textContent = `Teoria & Especificação Técnica — ${isHydra ? 'Cilindro Hidráulico' : 'Cilindro Pneumático'}`;
            elBody.innerHTML = formatIndustrialTheoryCard({
                title: cylTitle,
                subtitle: isHydra ? 'Atuador Oleodinâmico Pesado para Toneladas de Força' : 'Atuador Linear Industrial Rápido (6,0 bar)',
                color: cylColor,
                telemetryHtml: `
                    <div>• <b>Identificador / Tag:</b> <b style="color:var(--lc-white);">${node.tag || 'Manual (Conexão por Mangueiras)'}</b> | <b>Posição da Haste:</b> <b>${node.motionState}</b> (${(node.extension * 100).toFixed(0)}% do curso)</div>
                    <div>• <b>Fluido de Trabalho:</b> ${isHydra ? '<span style="color:#F59E0B; font-weight:bold;">Óleo Hidráulico ISO VG 46 (120 bar / Incompressível)</span>' : '<span style="color:#00E5FF; font-weight:bold;">Ar Comprimido 6,0 bar (Rápido / Pneumático)</span>'}</div>
                    <div>• <b>Válvula Vinculada:</b> ${node.linkedValve ? (node.linkedValve.tag || node.linkedValve.type) : '<span style="color:var(--lc-error);">Nenhuma (Conecte mangueiras manuais)</span>'}</div>
                    <div>• <b>Sensores Magnéticos em Presilha:</b> S0 (Recuo 0%): ${node.sensorS0 ? '<b style="color:var(--lc-success);">ATIVO (24V)</b>' : '0V'} | S1 (Avanço 100%): ${node.sensorS1 ? '<b style="color:var(--lc-success);">ATIVO (24V)</b>' : '0V'}</div>
                `,
                what: isSingle 
                    ? 'Atuador linear compacto dotado de uma única câmara de trabalho pressurizável e uma mola helicoidal interna mecânica responsável por efetuar o recuo automático da haste.'
                    : isHydra 
                        ? 'Atuador linear oleodinâmico pesado de alta rigidez estrutural, forjado em aço e dimensionado para operar com fluidos minerais incompressíveis sob pressões nominais de 120 bar (12 MPa), desenvolvendo elevadas forças estáticas e dinâmicas.'
                        : 'Atuador mecânico linear de dupla ação e perfil usinado conforme ISO 15552, composto por camisa de alumínio anodizado duro, êmbolo com anel magnético de neodímio e haste de aço retificado com cromo duro.',
                how: isSingle 
                    ? 'A injeção de ar comprimido no pórtico traseiro supera a pré-carga da mola helicoidal interna e empurra o êmbolo até o fim do curso. Ao cortar o ar e drenar a câmara para a atmosfera, a mola interna expande e devolve o êmbolo e a haste à posição recuada de repouso.'
                    : isHydra 
                        ? 'A força linear é produzida pela injeção forçada de óleo sob 120 bar em uma das câmaras estanques, enquanto a câmara oposta descarrega o fluido através da linha de retorno T para o tanque da HPU. Pela incompressibilidade do óleo, a velocidade permanece estável mesmo sob cargas oscilantes, sem efeito mola.'
                        : 'O movimento linear decorre do diferencial de pressão pneumática entre as duas câmaras estanques. Injetando 6 bar na câmara traseira 4(A) e drenando a dianteira 2(B), a haste avança com velocidade de até 1,5 m/s. Ao inverter os pórticos na válvula direcional, a haste recua. Os sensores magnéticos de presilha S0 e S1 fecham seus contatos de estado sólido quando o êmbolo magnético passa sob eles.',
                pinout: isSingle 
                    ? '<b>Pórtico 1(P)/A:</b> Entrada de ar de avanço.<br><b>Respiro Frontal:</b> Escape atmosférico para a mola.<br><b>Presilhas S0/S1:</b> Sensores de fim de curso ajustáveis.'
                    : isHydra 
                        ? '<b>Pórtico A:</b> Conexão de avanço (alta pressão).<br><b>Pórtico B:</b> Conexão de recuo (alta pressão).<br><b>Presilhas S0/S1:</b> Bornes rápidos 24V de sinal com LEDs indicadores.'
                        : '<b>Pórtico 4(A):</b> Câmara de avanço.<br><b>Pórtico 2(B):</b> Câmara de recuo.<br><b>Presilhas S0/S1:</b> Encaixe por abraçadeira Festo/SMC nos tirantes com saídas 24VDC e LEDs vermelho (S0) e amarelo (S1).',
                apps: isSingle 
                    ? 'Pinos de travamento mecânico, ejeção de peças cortadas e freios automáticos de segurança por perda de pressão.'
                    : isHydra 
                        ? 'Prensas industriais de estampagem pesada, mesas pantográficas de elevação de cargas, comportas hidráulicas e cilindros de inclinação de fornos de fundição.'
                        : 'Empurradores de caixas em esteiras de transporte, sistemas de montagem pick-and-place, manipuladores pneumáticos e dispositivos de fixação rápida de gabaritos.'
            }) + valveDiagramHtml + actuatorDynamicsHtml;
        } else if (core.VALVE_TYPES.has(node.type)) {
            const is32 = node.type === core.COMP.VALVE_3_2_MONO;
            const isHydra = (node.type === core.COMP.VALVE_4_2_MONO || node.type === core.COMP.VALVE_4_2_BI);
            const isBi = (node.type === core.COMP.VALVE_5_2_BI || node.type === core.COMP.VALVE_4_2_BI);
            const valveName = is32 ? 'Válvula Direcional Eletropneumática 3/2 Vias Monoestável'
                : isHydra ? (isBi ? 'Válvula Direcional Eletro-hidráulica 4/2 Vias Biestável (Duplo Solenoide)' : 'Válvula Direcional Eletro-hidráulica 4/2 Vias Monoestável')
                : (isBi ? 'Válvula Direcional Eletropneumática 5/2 Vias Biestável (Duplo Solenoide Y1/Y2)' : 'Válvula Direcional Eletropneumática 5/2 Vias Monoestável');
            const valveColor = isHydra ? '#F59E0B' : '#00E5FF';

            elTitle.textContent = `Teoria & Especificação Técnica — ${isHydra ? 'Válvula Hidráulica' : 'Válvula Pneumática'}`;
            elBody.innerHTML = formatIndustrialTheoryCard({
                title: `${valveName} (ISO 1219)`,
                subtitle: isHydra ? 'Distribuidor Oleodinâmico de Alta Pressão (120 bar)' : 'Distribuidor Eletropneumático com Carretel e Solenoide Integrado',
                color: valveColor,
                telemetryHtml: `
                    <div>• <b>Pressão Ativa:</b> ${node.hasPressure ? `<b style="color:var(--lc-success);">${node.pressureBar.toFixed(1)} bar</b>` : `<b style="color:var(--lc-error);">SEM PRESSÃO (0,0 bar - Verifique mangueiras)</b>`}</div>
                    ${node.isBlockedOverpressure ? `<div style="color:var(--lc-error); font-weight:bold; margin-top:4px;">⚠️ BLOQUEIO POR SOBREPRESSÃO: A linha de retorno ao tanque (T) da válvula deve ser conectada de volta à entrada T da HPU!</div>` : ''}
                    <div>• <b>Cilindro Conectado:</b> ${node.linkedCylinder ? (node.linkedCylinder.tag || node.linkedCylinder.type) : '<span style="color:var(--lc-warning);">Pendente (Conecte mangueiras manuais aos niples)</span>'}</div>
                `,
                what: 'Válvula direcional de distribuição fluídica usinada em bloco maciço de alumínio anodizado escuro, em conformidade com as normas ISO 1219 e DIN 24340. Possui carretel interno deslizante com solenoides e molas flangeados diretamente ao corpo usinado.',
                how: isBi 
                    ? 'Opera como uma memória fluídica biestável (flip-flop). Um pulso elétrico momentâneo em Y1 desloca o carretel para a posição de trabalho, onde ele permanece retido por inércia e atrito estático mesmo após o desligamento da bobina. A inversão só ocorre quando um pulso elétrico independente for aplicado na bobina oposta Y2.'
                    : 'Em repouso, a mola mecânica montada na extremidade direita mantém o carretel na posição normal, conectando a pressão à câmara de recuo e drenando a de avanço. Ao excitar a bobina de solenoide com +24VDC, a força magnética vence a mola e comuta o carretel, invertendo as conexões e direcionando a pressão para a câmara de avanço. Ao cortar a tensão, a mola retorna o carretel instantaneamente.',
                pinout: isHydra 
                    ? '<b>Pórtico P:</b> Alimentação de pressão da HPU (120 bar).<br><b>Pórtico T:</b> Retorno obrigatório de baixa pressão ao tanque do reservatório.<br><b>Pórticos A e B:</b> Linhas de trabalho ligadas às câmaras do cilindro.<br><b>Conector DIN A1:</b> Borne de acionamento elétrico 24VDC do solenoide.'
                    : '<b>Pórtico 1(P):</b> Entrada de ar comprimido 6 bar da FRL.<br><b>Pórticos 4(A) e 2(B):</b> Vias de trabalho para as câmaras do cilindro.<br><b>Pórticos 5(S) e 3(R):</b> Escapes atmosféricos com silenciadores de bronze.<br><b>Borne DIN A1:</b> Alimentação elétrica da bobina Y1.',
                apps: isHydra 
                    ? 'Controle de avanço e retorno de prensas e dobradeiras hidráulicas, acionamento de tesouras cortadoras e unidades de fechamento de moldes.'
                    : 'Comando principal de atuadores lineares em células robotizadas de montagem, ejetores automáticos e dispositivos de abertura de comportas.'
            }) + valveDiagramHtml + actuatorDynamicsHtml;
        } else if (core.SUPPLY_TYPES && core.SUPPLY_TYPES.has(node.type)) {
            const isPneu = (node.type === core.COMP.SUPPLY_PNEU);
            const supTitle = isPneu 
                ? 'Unidade de Conservação e Preparação FRL (6,0 bar / 0,6 MPa)'
                : 'Central Hidráulica de Potência HPU (120 bar / 12 MPa)';
            const supColor = isPneu ? '#00E5FF' : '#F59E0B';

            elTitle.textContent = `Teoria & Especificação Técnica — ${isPneu ? 'Alimentação FRL' : 'Central HPU'}`;
            elBody.innerHTML = formatIndustrialTheoryCard({
                title: supTitle,
                subtitle: isPneu ? 'Filtro Centrífugo, Regulador de Pressão com Manômetro e Lubrificador' : 'Grupo Motor-Bomba com Reservatório de Óleo ISO VG 46 e Linha de Retorno T',
                color: supColor,
                telemetryHtml: `
                    <div>• <b>Estado Operacional:</b> ${node.manualValue !== false ? '<b style="color:var(--lc-success);">PRESSURIZADA / LIGADA</b>' : '<b style="color:var(--lc-error);">DESLIGADA (Pressão Nula 0 bar)</b>'}</div>
                    <div>• <b>Pressão Nominal Calibrada:</b> <b>${isPneu ? '6,0 bar (0,6 MPa)' : '120 bar (12 MPa)'}</b></div>
                    <div style="color:var(--lc-yellow-400); margin-top:4px;">• <i>Dica: Clique com o botão esquerdo sobre o bloco na bancada para ligar ou desligar a unidade.</i></div>
                `,
                what: isPneu 
                    ? 'Estação de condicionamento e tratamento primário de ar comprimido (Filtro, Regulador e Lubrificador) instalada obrigatoriamente na entrada de todo painel pneumático para assegurar ar limpo, seco, regulado e lubrificado.'
                    : 'Unidade Hidráulica de Potência autônoma (Hydraulic Power Unit - HPU) constituída por reservatório metálico de óleo mineral, motor elétrico acoplador, bomba de engrenagens de deslocamento positivo, manômetro e válvula de segurança de alívio.',
                how: isPneu 
                    ? 'O ar comprimido proveniente do compressor passa primeiramente por palhetas centrífugas que separam a água e partículas sólidas > 5 µm; em seguida, o regulador de diafragma reduz e estabiliza a pressão a 6 bar constantes; por fim, a passagem de ar aciona um gotejador por depressão (tubo Venturi) que injeta uma micro-névoa de óleo lubrificante para proteger os cilindros e válvulas contra desgaste prematuro.'
                    : 'O motor elétrico rotaciona as engrenagens da bomba, aspirando fluido hidráulico do reservatório e descarregando-o sob pressão contínua de 120 bar através do pórtico P. O circuito é rigorosamente fechado: após acionar os cilindros, o óleo descarregado precisa retornar integralmente ao reservatório pelo pórtico T para decantação e troca térmica. Caso a linha T esteja ausente, o sistema bloqueia imediatamente por sobrepressão.',
                pinout: isPneu 
                    ? '<b>Niple de Saída Rápida 6 bar:</b> Engate rápido para mangueira flexível azul turquesa de poliuretano.'
                    : '<b>Pórtico P (Pressão):</b> Niple de alta pressão para mangueira âmbar.<br><b>Pórtico T (Tanque):</b> Niple de retorno de baixa pressão reforçado para o dreno do reservatório.',
                apps: isPneu 
                    ? 'Ponto de entrega de ar regulado para linhas de montagem, robótica flexível e bancadas didáticas industriais.'
                    : 'Alimentação hidráulica central para prensas pesadas de conformação de chapas, pontes elevatórias, guinchos industriais e injetoras plásticas.'
            }) + actuatorDynamicsHtml;
        } else if (core.GATE_TYPES.has(node.type)) {
            const deMorgan = core.getDeMorganEquivalent(node.type, node.inputCount);
            elTitle.textContent = `Teoria & Especificação Técnica — Porta Lógica ${node.type}`;
            elBody.innerHTML = formatIndustrialTheoryCard({
                title: `Porta Lógica ${node.type} — Circuito Integrado TTL 74xx`,
                subtitle: `Bloco Combinacional Básico (Álgebra Booleana)`,
                color: '#38BDF8',
                telemetryHtml: `
                    <div>• <b>Expressão Booleana:</b> <b style="color:var(--lc-yellow-400); font-family:monospace; font-size:14px;">${core.getGateExpression(node.type, node.inputCount)}</b></div>
                    <div>• <b>Nº de Entradas Ativas:</b> <b>${node.inputCount}</b> | <b>Nível Lógico de Saída S:</b> ${node.state ? '<b style="color:var(--lc-success);">1 (HIGH / +24V)</b>' : '<b style="color:var(--lc-error);">0 (LOW / 0V)</b>'}</div>
                    ${deMorgan ? `<div style="margin-top:6px; color:var(--lc-yellow-400);">• <b>Teorema de De Morgan:</b> ${deMorgan.original} ≡ ${deMorgan.equivalent} <span style="color:var(--lc-slate-300);">(${deMorgan.law})</span></div>` : ''}
                `,
                what: `Circuito integrado combinacional da família lógica TTL 74xx (Transistor-Transistor Logic), como o CI 7408 (AND), 7432 (OR), 7404 (NOT), 7400 (NAND), 7402 (NOR), 7486 (XOR) ou 74266 (XNOR). Executa uma operação matemática booleana fundamental entre as variáveis de entrada.`,
                how: `Transistores bipolares internos polarizados em corte ou saturação avaliam a tensão contínua das entradas A, B (e C, D) e comutam a saída S entre nível baixo (0V) e nível alto (+24V) com tempo de propagação na escala de nanossegundos, obedecendo à tabela-verdade do componente.`,
                pinout: `<b>Entradas de Sinal:</b> Bornes A, B (e C, D conforme configurado).<br><b>Saída Lógica S:</b> Borne de saída de sinal com LED indicador de estado no invólucro do CI.`,
                apps: `Circuitos de comando pré-CLP, intertravamentos de hardware de segurança intrínseca, somadores binários, detectores de paridade e síntese de lógica combinacional em automações fabris.`
            });
        } else if (node.type === core.COMP.SWITCH) {
            elTitle.textContent = 'Teoria & Especificação Técnica — Chave Seletora';
            elBody.innerHTML = formatIndustrialTheoryCard({
                title: 'Chave Seletora Binária Industrial (SW)',
                subtitle: 'Entrada Manual de Dados com Retenção Mecânica',
                color: '#38BDF8',
                telemetryHtml: `<div>• <b>Posição da Chave:</b> ${node.manualValue ? '<b style="color:var(--lc-success);">1 (LIGADA / +24VDC)</b>' : '<b style="color:var(--lc-error);">0 (DESLIGADA / 0V)</b>'}</div>`,
                what: 'Chave alavanca industrial de duas posições estáveis (biestável) projetada para entrada manual de dados e parametrização binária.',
                how: 'Ao ser comutada pelo operador, estabelece conexão mecânica direta e firme entre o barramento de alimentação de 24VDC e o borne de saída (nível 1 / HIGH) ou aterra a saída (nível 0 / LOW). O LED frontal na base indica visualmente a presença de tensão de comando.',
                pinout: '<b>Borne OUT:</b> Saída digital de controle em nível alto (24VDC) ou baixo (0V).',
                apps: 'Seletores de modo de operação Manual/Automático, chaves de habilitação de linha e geradores de palavras binárias de teste em painéis.'
            });
        } else if (['LAMP', 'LED_RED', 'BUZZER'].includes(node.type)) {
            const isBuzzer = (node.type === 'BUZZER');
            elTitle.textContent = `Teoria & Especificação Técnica — ${isBuzzer ? 'Buzzer Acústico' : 'Sinalizador Visual'}`;
            elBody.innerHTML = formatIndustrialTheoryCard({
                title: `Dispositivo de Sinalização Industrial (${node.type})`,
                subtitle: isBuzzer ? 'Alarme Sonoro Piezoelétrico 2,4 kHz (24VDC)' : 'Sinaleiro Luminoso Piloto Industrial (24VDC)',
                color: '#F59E0B',
                telemetryHtml: `<div>• <b>Estado Atual:</b> ${node.state ? '<b style="color:var(--lc-success);">ATIVO (24VDC - Emitindo Sinal)</b>' : '<b style="color:var(--lc-slate-300);">INATIVO (0V - Silencioso / Apagado)</b>'}</div>`,
                what: 'Atuador de sinalização eletro-óptica ou sonora de segurança para painéis de comando conforme a norma IEC 60073.',
                how: isBuzzer 
                    ? 'Uma pastilha de cerâmica piezoelétrica interna é excitada por um oscilador eletrônico ao receber 24VDC, vibrando em sua frequência de ressonância natural (2,4 kHz) para produzir advertência acústica contínua de alta audibilidade.'
                    : 'A corrente contínua circula através dos elementos emissores de luz (LED de alta eficiência ou filamento de lâmpada piloto), gerando fluxo luminoso de alta visibilidade mesmo sob iluminação intensa de chão de fábrica.',
                pinout: '<b>Borne IN:</b> Entrada de sinal de excitação (+24VDC).<br><b>Borne COM:</b> Referência Comum 0V.',
                apps: 'Colunas luminosas Andon em linhas de produção automatizadas, sinalização de sobreaquecimento de motores, alarme de início de ciclo de robôs e advertência de barreira óptica violada.'
            });
        } else if (node.type === core.COMP.SOLENOID_PNEU || node.type === core.COMP.SOLENOID_HYDRA) {
            const isPneuSol = (node.type === core.COMP.SOLENOID_PNEU);
            elTitle.textContent = 'Teoria & Especificação Técnica — Solenoide de Válvula';
            elBody.innerHTML = formatIndustrialTheoryCard({
                title: `Bobina de Solenoide Industrial DIN 43650 (${isPneuSol ? 'Pneumática' : 'Hidráulica'})`,
                subtitle: 'Atuador Eletromagnético de Pilotagem de Válvula Direcional',
                color: '#22C55E',
                telemetryHtml: `<div>• <b>Estado da Bobina:</b> ${node.state ? '<b style="color:var(--lc-success);">1 (ENERGIZADA / CAMPO ATIVO)</b>' : '<b style="color:var(--lc-slate-300);">0 (DESENERGIZADA / EM REPOUSO)</b>'}</div>`,
                what: 'Eletroímã de acionamento rápido encapsulado em resina epóxi impermeável com conector elétrico padronizado DIN 43650, montado sobre o cabeçote da válvula direcional.',
                how: 'Ao ser energizado com 24VDC através do borne A1, a circulação de corrente no enrolamento gera um potente campo magnético axial que atrai o induzido de ferro (carretel da válvula) contra a mola, abrindo as passagens fluídicas de trabalho. Um diodo interno supressor absorve o pico de tensão reversa na desenergização.',
                pinout: '<b>Borne A1:</b> Terminal de comando positivo (+24VDC).<br><b>Borne de Retorno:</b> Conexão de referência comum 0V.',
                apps: 'Pilotagem de válvulas direcionais eletropneumáticas e eletro-hidráulicas em automações fabris e circuitos sequenciais.'
            }) + valveDiagramHtml + actuatorDynamicsHtml;
        } else if (node.type === core.COMP.MOTOR_INDUCTION_6P) {
            elTitle.textContent = 'Teoria & Especificação Técnica — Motor Trifásico 6P';
            elBody.innerHTML = formatIndustrialTheoryCard({
                title: 'Motor de Indução Trifásico com Rotor em Gaiola — 6 Pontas (NBR 17094 / IEC 60034)',
                subtitle: 'Máquina Assíncrona de CA (220V Δ / 380V Y — 4 Polos / 60 Hz / 1750 RPM)',
                color: '#38BDF8',
                telemetryHtml: `
                    <div>• <b>Velocidade Mecânica do Eixo:</b> <b style="color:var(--lc-yellow-400); font-size:13.5px;">${node.rpm ? node.rpm.toFixed(0) : '0'} RPM</b> (${node.direction || 'Parado'})</div>
                    <div>• <b>Fechamento Eletrotécnico:</b> <b style="color:${node.stalled ? 'var(--lc-error)' : 'var(--lc-success)'};">${node.connectionType || 'DESENERGIZADO'}</b></div>
                    <div>• <b>Corrente de Linha Simulada:</b> <b>${node.current ? node.current.toFixed(1) + ' A' : '0.0 A'}</b> | <b>Aterramento PE:</b> ${node.grounded ? '<b style="color:var(--lc-success);">CONECTADO (Carcaça Protegida)</b>' : '<b style="color:var(--lc-error);">NÃO CONECTADO (Risco de Choque)</b>'}</div>
                    ${node.fault ? `<div style="color:var(--lc-error); font-weight:bold; margin-top:6px;">⚠️ ${node.fault}</div>` : ''}
                `,
                what: 'Máquina motriz assíncrona trifásica de alta eficiência com rotor em gaiola de esquilo de alumínio injetado e estator com 3 enrolamentos independentes desfasados espacialmente em 120º geométricos, totalizando 6 terminais acessíveis na placa de bornes (U1-U2, V1-V2, W1-W2).',
                how: 'A aplicação de tensões trifásicas senoidais defasadas de 120º elétricos no estator gera um campo magnético girante que corta os condutores do rotor. Pela Lei de Faraday-Lenz, surgem correntes induzidas no rotor que interagem com o campo girante, produzindo conjugado eletromecânico com velocidade assíncrona (1750 RPM com escorregamento nominal s ≈ 2,8%). O sentido de rotação é definido pela sequência de fases (L1-L2-L3 = Horário; invertendo quaisquer duas fases entre si = Anti-horário).',
                pinout: '<b>Placa de Bornes 3x2:</b><br>' +
                        '• Fila Superior: <b>W2</b> (Fim da Fase 3), <b>U2</b> (Fim da Fase 1), <b>V2</b> (Fim da Fase 2).<br>' +
                        '• Fila Inferior: <b>U1</b> (Início da Fase 1), <b>V1</b> (Início da Fase 2), <b>W1</b> (Início da Fase 3).<br>' +
                        '• <b>Fechamento Estrela (Y - 380V):</b> Jumper horizontal unindo W2-U2-V2 (ponto neutro/centro da estrela) e alimentação L1 em U1, L2 em V1, L3 em W1.<br>' +
                        '• <b>Fechamento Triângulo (Δ - 220V):</b> Três jumpers verticais unindo U1-W2, V1-U2 e W1-V2, recebendo as fases L1, L2 e L3.<br>' +
                        '• <b>Borne PE:</b> Parafuso verde de aterramento da carcaça para equalização de potencial (NR-10).',
                apps: 'Acionamento principal de esteiras transportadoras industriais, bombas centrífugas de água, compressores de ar tipo parafuso, ventiladores de tiragem, moinhos e tornos mecânicos CNC.'
            });
        } else if (node.type === core.COMP.MOTOR_INDUCTION_MONO) {
            elTitle.textContent = 'Teoria & Especificação Técnica — Motor Monofásico c/ Capacitor';
            elBody.innerHTML = formatIndustrialTheoryCard({
                title: 'Motor de Indução Monofásico com Capacitor Permanente de Partida',
                subtitle: 'Motor Assíncrono com Enrolamento Principal e Auxiliar Desfasado (220V CA — 1740 RPM)',
                color: '#F59E0B',
                telemetryHtml: `
                    <div>• <b>Velocidade do Eixo:</b> <b style="color:var(--lc-yellow-400); font-size:13.5px;">${node.rpm ? node.rpm.toFixed(0) : '0'} RPM</b> (${node.direction || 'Parado'})</div>
                    <div>• <b>Status Operacional:</b> <b style="color:${node.stalled ? 'var(--lc-error)' : 'var(--lc-success)'};">${node.connectionType || 'DESENERGIZADO'}</b></div>
                    <div>• <b>Corrente de Operação:</b> <b>${node.current ? node.current.toFixed(1) + ' A' : '0.0 A'}</b> | <b>Aterramento PE:</b> ${node.grounded ? '<b style="color:var(--lc-success);">CONECTADO</b>' : '<b style="color:var(--lc-error);">NÃO CONECTADO</b>'}</div>
                    ${node.fault ? `<div style="color:var(--lc-error); font-weight:bold; margin-top:6px;">⚠️ ${node.fault}</div>` : ''}
                `,
                what: 'Motor elétrico monofásico de indução desenvolvido para locais sem suprimento de rede trifásica. Possui dois enrolamentos no estator: Enrolamento Principal (U1-U2, fio de maior calibre) e Enrolamento Auxiliar (Z1-Z2) com capacitor de polipropileno em série (C1-C2).',
                how: 'Uma rede monofásica aplicada a um enrolamento único gera apenas um campo magnético pulsante estacionário no espaço, incapaz de acelerar o rotor parado (conjugado de partida nulo). Para produzir partida autônoma, o capacitor em série com o enrolamento auxiliar introduz um desfasamento elétrico de 90º na corrente, gerando um campo elíptico girante que arrasta o rotor. Se o enrolamento principal for ligado sem o capacitor/auxiliar, o motor entra em <b>Stall (Rotor Bloqueado)</b>, emitindo zumbido magnético a 60 Hz e corrente elevada (>12 A) que desarma o relé térmico.',
                pinout: '<b>Enrolamento Principal:</b> Bornes U1 e U2 (ligados à fase e ao neutro da rede 220V).<br>' +
                        '<b>Enrolamento Auxiliar:</b> Bornes Z1 e Z2.<br>' +
                        '<b>Capacitor:</b> Bornes C1 e C2 (em série com o auxiliar Z1-Z2).<br>' +
                        '<b>Sentido Horário:</b> L1 em U1 e Z1; Neutro N em U2 e C2; com jumper entre Z2 e C1.<br>' +
                        '<b>Sentido Anti-Horário (Inversão):</b> Inverter as conexões do enrolamento auxiliar Z1-Z2.<br>' +
                        '<b>Borne PE:</b> Aterramento da carcaça.',
                apps: 'Bombas centrífugas residenciais e prediais, serras circulares de bancada, betoneiras civis, compressores de ar monofásicos e portões automáticos de garagem.'
            });
        } else if (node.type === core.COMP.CONTACTOR_3P) {
            elTitle.textContent = 'Teoria & Especificação Técnica — Contator Tripolar K1';
            elBody.innerHTML = formatIndustrialTheoryCard({
                title: 'Contator Eletromecânico de Potência Tripolar com Contato Auxiliar Integrado',
                subtitle: 'Chaveamento de Cargas Indutivas AC-3 (Siemens Sirius / Schneider TeSys — 24Vdc / 380V)',
                color: '#38BDF8',
                telemetryHtml: `
                    <div>• <b>Estado da Bobina (A1/A2):</b> <b style="color:${node.state ? 'var(--lc-success)' : 'var(--lc-slate-400)'};">${node.state ? 'ENERGIZADA (Contatos Atraídos)' : 'DESENERGIZADA (Em Repouso)'}</b></div>
                    <div>• <b>Contatos Principais de Força:</b> <b>1/L1→2/T1: ${node.outputStates?.['2/T1'] ? 'FECHADO' : 'ABERTO'} | 3/L2→4/T2: ${node.outputStates?.['4/T2'] ? 'FECHADO' : 'ABERTO'} | 5/L3→6/T3: ${node.outputStates?.['6/T3'] ? 'FECHADO' : 'ABERTO'}</b></div>
                    <div>• <b>Contato Auxiliar 13-14 (NA):</b> <b style="color:${node.outputStates?.['14'] ? 'var(--lc-success)' : 'var(--lc-slate-400)'};">${node.outputStates?.['14'] ? 'CONDUZINDO (Selo Ativo)' : 'ABERTO'}</b></div>
                `,
                what: 'Dispositivo eletromecânico industrial projetado para manobrar correntes de alta intensidade em motores elétricos trifásicos a partir de sinais de comando de baixa potência (24Vdc). Possui 3 contatos de força e 1 contato auxiliar NA integrado.',
                how: 'Quando a bobina A1/A2 recebe 24Vdc, cria-se um campo magnético que atrai o núcleo ferromagnético móvel (carretel/plunger), vencendo a força das molas antagônicas. Isso fecha simultaneamente os 3 contatos principais de força (1/L1→2/T1, 3/L2→4/T2, 5/L3→6/T3) e o contato auxiliar 13-14 (usado para autorretenção / circuito de selo). Ao cessar o comando em A1, as molas abrem os contatos instantaneamente.',
                pinout: '<b>Circuito de Comando:</b><br>' +
                        '• <b>A1 / A2:</b> Terminais da bobina eletromagnética (24Vdc).<br>' +
                        '• <b>13 / 14:</b> Contato normalmente aberto (NA) para circuito de selo.<br>' +
                        '<b>Circuito de Força:</b><br>' +
                        '• <b>1/L1, 3/L2, 5/L3:</b> Entrada das fases da rede trifásica.<br>' +
                        '• <b>2/T1, 4/T2, 6/T3:</b> Saída trifásica conectada diretamente aos bornes U1, V1, W1 do motor.',
                apps: 'Partida direta de motores trifásicos, circuitos de reversão com intertravamento (K1 e K2), partida estrela-triângulo, comando de resistores industriais e sistemas de bombeamento.'
            });
        } else if (node.type === core.COMP.POWER_SUPPLY_3P) {
            elTitle.textContent = 'Teoria & Especificação Técnica — Rede Trifásica & Proteção';
            elBody.innerHTML = formatIndustrialTheoryCard({
                title: 'Alimentação Industrial Trifásica 380V/220V com Proteção de Aterramento (NR-10)',
                subtitle: 'Fornecimento de Potência CA 60Hz com Barramento de Equipotencialização PE',
                color: '#EF4444',
                telemetryHtml: `
                    <div>• <b>Chave Seletora Geral:</b> <b style="color:${node.manualValue !== false ? 'var(--lc-success)' : 'var(--lc-error)'};">${node.manualValue !== false ? 'LIGADA (380V / Fases R-S-T Ativas)' : 'SECCIONADA (0V)'}</b></div>
                    <div>• <b>Condutores Ativos:</b> <b>Fases L1, L2, L3 + Neutro N + Terra PE</b></div>
                    <div>• <b>Status NR-10:</b> <b style="color:var(--lc-success);">Barramento de Proteção PE Disponível para Carcaças</b></div>
                `,
                what: 'Painel didático industrial de distribuição trifásica regulamentado conforme a norma NR-10 e ABNT NBR 5410. Fornece tensão de linha trifásica (380V entre fases) e tensão de fase (220V fase-neutro) para a bancada.',
                how: 'As três fases senoidais (L1, L2, L3) possuem desfasamento angular temporal de 120º elétricos. A chave rotativa geral secciona todos os condutores de fase simultaneamente. O condutor de aterramento de proteção (PE) é permanente e ininterrupto, garantindo que qualquer corrente de fuga para a carcaça metálica escoe com segurança sem expor o operador a choque elétrico.',
                pinout: '• <b>L1 (Preto):</b> Fase R da rede.<br>' +
                        '• <b>L2 (Marrom):</b> Fase S da rede.<br>' +
                        '• <b>L3 (Cinza):</b> Fase T da rede.<br>' +
                        '• <b>N (Azul):</b> Condutor Neutro.<br>' +
                        '• <b>PE (Verde/Amarelo):</b> Condutor de Proteção / Terra de Carcaça (NR-10 obrigatório).',
                apps: 'Alimentação geral de centros de controle de motores (CCM), máquinas de usinagem CNC, quadros de distribuição industrial e bancadas didáticas de eletromecânica.'
            });
        } else {
            const deMorgan = core.getDeMorganEquivalent(node.type, node.inputCount);
            elTitle.textContent = `Teoria & Especificação Técnica — ${node.type}`;
            elBody.innerHTML = `
                <div class="diag-card">
                    <div class="diag-card-title">Componente: ${node.type}</div>
                    <p>Expressão Canônica: <b>${core.getGateExpression(node.type, node.inputCount)}</b></p>
                    <p>Entradas Ativas: <b>${node.inputCount}</b> | Nível Lógico de Saída: <b>${node.state ? '1 (HIGH)' : '0 (LOW)'}</b></p>
                    ${deMorgan ? `<p style="margin-top:8px; color:var(--lc-yellow-400);"><b>Equivalência de De Morgan:</b> ${deMorgan.original} ≡ ${deMorgan.equivalent}<br><small style="color:var(--lc-slate-300);">${deMorgan.law}</small></p>` : ''}
                </div>
            `;
        }
    }

    function renderTruthTableModal() {
        let node = getFocusedNode();

        // Se não houver nó selecionado no cursor, busca o primeiro nó disponível na bancada pertencente aos combinacionais
        if (!node && state.circuit.size > 0) {
            for (const n of state.circuit.values()) {
                if (core.GATE_TYPES.has(n.type) || n.type === core.COMP.DEC_BCD_7SEG) {
                    node = n;
                    state.focusedNodeKey = core.key(n.x, n.y, n.z);
                    state.modalLockedNodeKey = state.focusedNodeKey;
                    state.lockedInspectionNodeKey = state.focusedNodeKey;
                    break;
                }
            }
        }

        const elTitle = document.getElementById('modal-title');
        const elBody = document.getElementById('modal-body');
        if (!elTitle || !elBody) return;

        const isCombinational = node && (core.GATE_TYPES.has(node.type) || node.type === core.COMP.DEC_BCD_7SEG);

        if (!isCombinational) {
            elTitle.textContent = 'Tabela-Verdade — Bloco Combinacional';
            elBody.innerHTML = `
                <div class="diag-card" style="border-left: 4px solid var(--lc-warning); background: rgba(245, 158, 11, 0.08); padding: 18px 20px;">
                    <div class="diag-card-title" style="color: var(--lc-warning); display:flex; align-items:center; gap:8px; font-size:14px; margin-bottom:8px;">
                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="8" x2="12" y2="12"></line><line x1="12" y1="16" x2="12.01" y2="16"></line></svg>
                        Incompatibilidade Didática
                    </div>
                    <p style="margin:0; color:var(--lc-slate-200); font-size:13.5px; line-height:1.5;">
                        Ferramenta aplicável apenas a blocos combinacionais (Portas 74xx e Decodificadores BCD). Para atuadores e comandos, consulte a aba Teoria.
                    </p>
                </div>
            `;
            return;
        }

        if (core.GATE_TYPES.has(node.type)) {
            const table = core.generateTruthTable(node.type, node.inputCount);
            const activeRow = core.getActiveTruthTableRow(node.evaluatedInputs || []);
            elTitle.textContent = `Tabela-Verdade — ${node.type} (${node.inputCount} Entradas)`;
            let html = `<div class="truth-table-container"><table class="truth-table-full"><thead><tr><th>Mintermo</th>${Array.from({ length: node.inputCount }, (_, i) => `<th>${String.fromCodePoint(65 + i)}</th>`).join('')}<th>Saída S</th></tr></thead><tbody>`;
            table.forEach((row, idx) => { 
                html += `<tr class="${idx === activeRow ? 'row-active' : ''}"><td>m${row.minterm}</td>${row.inputs.map(v => `<td>${v}</td>`).join('')}<td><b>${row.output}</b></td></tr>`; 
            });
            html += `</tbody></table></div>`;
            elBody.innerHTML = html;
        } else if (node.type === core.COMP.DEC_BCD_7SEG) {
            elTitle.textContent = 'Tabela de Decodificação — BCD para 7 Segmentos';
            let html = `<div class="truth-table-container"><table class="truth-table-full"><thead><tr><th>Dígito</th><th>A</th><th>B</th><th>C</th><th>D</th><th>a</th><th>b</th><th>c</th><th>d</th><th>e</th><th>f</th><th>g</th></tr></thead><tbody>`;
            core.BCD_TABLE.forEach(r => {
                html += `<tr><td><b>${r.dec}</b></td><td>${r.a}</td><td>${r.b}</td><td>${r.c}</td><td>${r.d}</td><td>${r.segs.a}</td><td>${r.segs.b}</td><td>${r.segs.c}</td><td>${r.segs.d}</td><td>${r.segs.e}</td><td>${r.segs.f}</td><td>${r.segs.g}</td></tr>`;
            });
            html += `</tbody></table></div>`;
            elBody.innerHTML = html;
        }
    }

    function renderKarnaughModal() {
        let node = getFocusedNode();

        // Se não houver nó selecionado no cursor, busca o primeiro nó disponível na bancada pertencente aos combinacionais
        if (!node && state.circuit.size > 0) {
            for (const n of state.circuit.values()) {
                if (core.GATE_TYPES.has(n.type) || n.type === core.COMP.DEC_BCD_7SEG) {
                    node = n;
                    state.focusedNodeKey = core.key(n.x, n.y, n.z);
                    state.modalLockedNodeKey = state.focusedNodeKey;
                    state.lockedInspectionNodeKey = state.focusedNodeKey;
                    break;
                }
            }
        }

        const elTitle = document.getElementById('modal-title');
        const elBody = document.getElementById('modal-body');
        if (!elTitle || !elBody) return;

        const isCombinational = node && (core.GATE_TYPES.has(node.type) || node.type === core.COMP.DEC_BCD_7SEG);

        if (!isCombinational) {
            elTitle.textContent = 'Mapa de Karnaugh — Bloco Combinacional';
            elBody.innerHTML = `
                <div class="diag-card" style="border-left: 4px solid var(--lc-warning); background: rgba(245, 158, 11, 0.08); padding: 18px 20px;">
                    <div class="diag-card-title" style="color: var(--lc-warning); display:flex; align-items:center; gap:8px; font-size:14px; margin-bottom:8px;">
                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="8" x2="12" y2="12"></line><line x1="12" y1="16" x2="12.01" y2="16"></line></svg>
                        Incompatibilidade Didática
                    </div>
                    <p style="margin:0; color:var(--lc-slate-200); font-size:13.5px; line-height:1.5;">
                        Ferramenta aplicável apenas a blocos combinacionais (Portas 74xx e Decodificadores BCD). Para atuadores e comandos, consulte a aba Teoria.
                    </p>
                </div>
            `;
            return;
        }

        let kData = null;
        let isBcd = false;

        if (node.type === core.COMP.DEC_BCD_7SEG) {
            isBcd = true; 
            kData = core.buildBcdKarnaughMap(state.currentBcdSegmentSelected);
            elTitle.textContent = `Mapa de Karnaugh — Segmento '${state.currentBcdSegmentSelected}' (Display BCD)`;
        } else {
            kData = core.buildKarnaughMap(node);
            elTitle.textContent = `Mapa de Karnaugh — Nó: ${node.type} (${kData.activeSwitches.join(', ')})`;
        }

        const layout = kData.layout;
        const nVars = layout.nVars;
        const sw = kData.activeSwitches || ['A', 'B', 'C', 'D'];

        let bcdSelectorHtml = '';
        if (isBcd) {
            bcdSelectorHtml = `
                <div class="segment-selector-bar">
                    ${['a','b','c','d','e','f','g'].map(seg => `
                        <button class="btn-seg ${state.currentBcdSegmentSelected === seg ? 'active' : ''}" data-seg="${seg}">${seg}</button>
                    `).join('')}
                </div>
            `;
        }

        let tableHtml = `<table class="kmap-unified-table">`;

        if (nVars === 2) {
            tableHtml += `
                <tr>
                    <td class="kmap-corner"></td>
                    <td class="kmap-ruler-cell label-green"><span class="var-over">${sw[1]}</span></td>
                    <td class="kmap-ruler-cell label-green">${sw[1]}</td>
                </tr>
            `;
        } else if (nVars === 3) {
            tableHtml += `
                <tr>
                    <td class="kmap-corner"></td>
                    <td colspan="2" class="kmap-ruler-cell label-green"><span class="var-over">${sw[1]}</span></td>
                    <td colspan="2" class="kmap-ruler-cell label-green">${sw[1]}</td>
                </tr>
            `;
        } else {
            tableHtml += `
                <tr>
                    <td class="kmap-corner"></td>
                    <td colspan="2" class="kmap-ruler-cell label-green"><span class="var-over">${sw[2]}</span></td>
                    <td colspan="2" class="kmap-ruler-cell label-green">${sw[2]}</td>
                    <td class="kmap-corner"></td>
                </tr>
            `;
        }

        kData.grid.forEach((row, rIdx) => {
            tableHtml += `<tr>`;

            if (nVars === 2 || nVars === 3) {
                if (rIdx === 0) tableHtml += `<td class="kmap-ruler-cell label-red"><span class="var-over">${sw[0]}</span></td>`;
                else tableHtml += `<td class="kmap-ruler-cell label-red">${sw[0]}</td>`;
            } else {
                if (rIdx === 0) tableHtml += `<td rowspan="2" class="kmap-ruler-cell label-red"><span class="var-over">${sw[0]}</span></td>`;
                else if (rIdx === 2) tableHtml += `<td rowspan="2" class="kmap-ruler-cell label-red">${sw[0]}</td>`;
            }

            row.forEach((cell) => {
                const isSelected = (state.selectedKarnaughMinterms || []).includes(cell.minterm);
                const isX = (cell.value === 'X');
                const is1 = (cell.value === 1);

                let groupClasses = '';
                (state.karnaughGroups || []).forEach((g, gIdx) => {
                    if (g.minterms.includes(cell.minterm)) {
                        groupClasses += ` kgroup-saved-${gIdx % 4}`;
                    }
                });

                tableHtml += `
                    <td class="kmap-img-cell ${isSelected ? 'selected-free' : ''} ${groupClasses}" data-minterm="${cell.minterm}">
                        <span class="cell-val ${isX ? 'val-x' : (is1 ? 'val-0' : 'val-0')}">${cell.value}</span>
                        <span class="cell-tag">m${cell.minterm}</span>
                    </td>
                `;
            });

            if (nVars === 4) {
                if (rIdx === 0) tableHtml += `<td class="kmap-ruler-cell label-yellow"><span class="var-over">${sw[1]}</span></td>`;
                else if (rIdx === 1) tableHtml += `<td rowspan="2" class="kmap-ruler-cell label-yellow">${sw[1]}</td>`;
                else if (rIdx === 3) tableHtml += `<td class="kmap-ruler-cell label-yellow"><span class="var-over">${sw[1]}</span></td>`;
            }

            tableHtml += `</tr>`;
        });

        if (nVars === 3) {
            tableHtml += `
                <tr>
                    <td class="kmap-corner"></td>
                    <td class="kmap-ruler-cell label-blue"><span class="var-over">${sw[2]}</span></td>
                    <td colspan="2" class="kmap-ruler-cell label-blue">${sw[2]}</td>
                    <td class="kmap-ruler-cell label-blue"><span class="var-over">${sw[2]}</span></td>
                </tr>
            `;
        } else if (nVars === 4) {
            tableHtml += `
                <tr>
                    <td class="kmap-corner"></td>
                    <td class="kmap-ruler-cell label-blue"><span class="var-over">${sw[3]}</span></td>
                    <td colspan="2" class="kmap-ruler-cell label-blue">${sw[3]}</td>
                    <td class="kmap-ruler-cell label-blue"><span class="var-over">${sw[3]}</span></td>
                    <td class="kmap-corner"></td>
                </tr>
            `;
        }

        tableHtml += `</table>`;

        const html = `
            ${bcdSelectorHtml}
            <div class="kmap-scroll-container">
                <div class="kmap-unified-wrapper">
                    <div style="font-size: 0.75rem; color: var(--lc-slate-300); margin-bottom: 12px; text-align: center;">
                        Circuito mapeado para as entradas: <b>${sw.join(', ')}</b> (${nVars} Bits)
                    </div>
                    ${tableHtml}
                    <div class="kmap-free-bar">
                        <span class="kmap-status-txt">Células selecionadas: <b>${(state.selectedKarnaughMinterms || []).length}</b></span>
                        <div style="display:flex; gap:8px;">
                            <button class="btn-act btn-primary" id="btn-k-save-group">Salvar Agrupamento</button>
                            <button class="btn-act" id="btn-k-clear-sel">Limpar Seleção</button>
                            <button class="btn-act btn-danger" id="btn-k-reset-all">Remover Grupos</button>
                        </div>
                    </div>
                </div>
            </div>
        `;

        let groupsListHtml = '';
        if (state.karnaughGroups && state.karnaughGroups.length > 0) {
            groupsListHtml += `
                <div class="diag-card" style="margin-top:14px;">
                    <div class="diag-card-title">Agrupamentos Salvos (${state.karnaughGroups.length})</div>
                    <div style="display:flex; flex-direction:column; gap:6px;">
            `;
            state.karnaughGroups.forEach((g, idx) => {
                groupsListHtml += `
                    <div class="kmap-group-info" style="border-left: 4px solid var(--kgroup-${idx % 4});">
                        <b>G${idx + 1} (${g.size} células):</b> Termo <b style="color:var(--lc-yellow-400); font-size:14px;">${formatBooleanTerm(g.expression)}</b> | Mintermos: m(${g.minterms.join(', ')})
                    </div>
                `;
            });
            groupsListHtml += `</div>`;

            const finalExpression = state.karnaughGroups.map(g => formatBooleanTerm(g.expression)).join(' + ');
            const funcName = isBcd ? `${state.currentBcdSegmentSelected}` : `S(${sw.join(',')})`;
            groupsListHtml += `
                <div class="kmap-function-box" style="margin-top:12px;">
                    <div style="font-size:11px; color:var(--lc-slate-300); margin-bottom:6px; text-transform:uppercase;">Função Lógica Simplificada da Saída</div>
                    <h3 style="font-size:20px;">${funcName} = ${finalExpression}</h3>
                </div>
            </div>`;
        }

        elBody.innerHTML = html + groupsListHtml;

        elBody.querySelectorAll('.kmap-img-cell').forEach(td => {
            td.addEventListener('click', () => {
                const m = Number.parseInt(td.dataset.minterm, 10);
                core.toggleKarnaughCellSelection(m);
                renderKarnaughModal();
            });
        });

        bindClick('btn-k-save-group', () => {
            const res = core.saveCurrentKarnaughGroup(kData);
            if (res.success) {
                showToast('success', res.message);
                renderKarnaughModal();
            } else {
                showToast('error', res.message);
            }
        });

        bindClick('btn-k-clear-sel', () => {
            state.selectedKarnaughMinterms = [];
            renderKarnaughModal();
        });

        bindClick('btn-k-reset-all', () => {
            core.clearKarnaughGroups();
            state.selectedKarnaughMinterms = [];
            showToast('info', 'Todos os agrupamentos foram removidos.');
            renderKarnaughModal();
        });

        if (isBcd) {
            elBody.querySelectorAll('.btn-seg').forEach(btn => btn.addEventListener('click', () => {
                const newSeg = btn.dataset.seg;
                if (state.currentBcdSegmentSelected !== newSeg) {
                    state.currentBcdSegmentSelected = newSeg;
                    core.clearKarnaughGroups();
                    state.selectedKarnaughMinterms = [];
                    renderKarnaughModal();
                }
            }));
        }
    }

    function initUIEvents() {
        loadCompletedPhases();

        bindClick('btn-start-tour', () => {
            const screen = document.getElementById('onboarding-screen');
            if (screen) screen.classList.remove('open');
            localStorage.setItem('logiccraft_onboarded', 'true');
        });
        bindClick('btn-skip-tour', () => {
            const screen = document.getElementById('onboarding-screen');
            if (screen) screen.classList.remove('open');
            localStorage.setItem('logiccraft_onboarded', 'true');
        });
        bindClick('btn-help-tour', () => {
            const screen = document.getElementById('onboarding-screen');
            if (screen) screen.classList.add('open');
        });

        function updateSoundIcon(isMuted) {
            const iconOn = document.getElementById('icon-sound-on');
            const iconMuted = document.getElementById('icon-sound-muted');
            const btn = document.getElementById('btn-toggle-sound');
            if (iconOn && iconMuted) {
                iconOn.style.display = isMuted ? 'none' : 'block';
                iconMuted.style.display = isMuted ? 'block' : 'none';
            }
            if (btn) {
                btn.title = isMuted ? 'Ativar Sons Industriais (Mudo)' : 'Desativar Sons Industriais (Ativo)';
            }
        }
        bindClick('btn-toggle-sound', () => {
            const isMuted = window.LogicCraft?.audio?.toggleMute();
            updateSoundIcon(isMuted);
            showToast('info', isMuted ? 'Áudio industrial silenciado.' : 'Áudio industrial ativado.');
        });
        updateSoundIcon(Boolean(window.LogicCraft?.audio?.isSoundMuted()));

        bindClick('btn-camera-reset', () => sim.resetCameraView());
        bindClick('btn-undo', () => sim.undoLastAction());
        bindClick('btn-redo', () => sim.redoLastAction());
        
        bindClick('btn-demo-bcd', () => sim.loadBcdExample());
        bindClick('btn-demo-pneu', () => { if(sim.loadPneumaticExample) sim.loadPneumaticExample(); });
        bindClick('btn-demo-hydra', () => { if(sim.loadHydraulicExample) sim.loadHydraulicExample(); });
        bindClick('btn-demo-timeout', () => sim.loadTimeoutDemo());
        bindClick('btn-demo-autocycle', () => { if (sim.load4BitBusDemo) sim.load4BitBusDemo(); else if (sim.loadAutoCycleDemo) sim.loadAutoCycleDemo(); });
        bindClick('btn-demo-motor', () => sim.loadMotorLogicDemo());
        bindClick('btn-demo-conveyor', () => {
            if (window.LogicCraft?.conveyorCell?.openDemo) {
                window.LogicCraft.conveyorCell.openDemo();
            }
        });

        bindClick('btn-fundamentals', () => { openModal('fundamentals'); renderFundamentalsModal(); });
        bindClick('btn-truth-table', () => { openModal('truth-table'); renderTruthTableModal(); });
        bindClick('btn-karnaugh', () => { openModal('karnaugh'); renderKarnaughModal(); });

        bindClick('btn-challenge-toggle', () => {
            challengeModeOpen = !challengeModeOpen;
            const panel = document.getElementById('challenge-panel');
            if (panel) panel.style.display = challengeModeOpen ? 'block' : 'none';
            if (challengeModeOpen) {
                updatePhaseButtonsUI();
                renderChallengePanel();
            }
        });

        bindClick('btn-ch-close', () => {
            challengeModeOpen = false;
            const panel = document.getElementById('challenge-panel');
            if (panel) panel.style.display = 'none';
        });

        PHASES_ORDER.forEach((cat, idx) => {
            bindClick(`btn-cat-${cat}`, () => {
                if (!isPhaseUnlocked(cat)) {
                    showToast('warning', `🔒 Fase ${idx + 1} bloqueada! Conclua a Fase ${idx} para liberar o acesso.`);
                    if (window.LogicCraft?.audio?.playContactorClack) {
                        window.LogicCraft.audio.playContactorClack(true);
                    }
                    return;
                }
                challengeCategory = cat;
                currentChIdx = 0;
                selectedQuizOption = null;
                document.querySelectorAll('.btn-cat').forEach(b => b.classList.remove('active'));
                document.getElementById(`btn-cat-${cat}`)?.classList.add('active');
                renderChallengePanel();
            });
        });

        bindClick('btn-reset', () => { sim.clearCircuit(); });
        bindClick('btn-export-circuit', () => sim.exportCircuitToFile());
        bindClick('btn-import-circuit', () => {
            const input = document.getElementById('input-import-circuit');
            if (input) input.click();
        });

        const importInput = document.getElementById('input-import-circuit');
        if (importInput) {
            importInput.addEventListener('change', (e) => {
                const file = e.target.files && e.target.files[0];
                if (!file) return;
                const reader = new FileReader();
                reader.onload = (ev) => {
                    sim.importCircuitFromFile(ev.target.result);
                    importInput.value = '';
                };
                reader.onerror = () => {
                    showToast('error', 'Erro ao ler o arquivo selecionado.');
                    importInput.value = '';
                };
                reader.readAsText(file);
            });
        }
        
        bindClick('btn-ch-hint', () => { 
            const list = getCurrentChallengeList();
            const ch = list[currentChIdx];
            showToast('info', ch.hint || 'Sem dicas adicionais.'); 
        });
        bindClick('btn-ch-validate', () => validateCurrentChallenge());
        bindClick('btn-ch-next', () => { 
            const list = getCurrentChallengeList(); 
            currentChIdx = (currentChIdx + 1) % list.length; 
            selectedQuizOption = null; 
            renderChallengePanel(); 
        });

        bindClick('modal-close-btn', closeAllModals);
        bindClick('modal-btn-confirm', closeAllModals);
        const modalBg = document.getElementById('modal-screen');
        if (modalBg) {
            modalBg.addEventListener('click', (e) => {
                if (e.target === modalBg) closeAllModals();
            });
        }

        document.querySelectorAll('.btn-count').forEach(btn => btn.addEventListener('click', () => {
            if (btn.disabled) return;
            state.currentSelection.inputCount = Number.parseInt(btn.dataset.in, 10);
            updateInputCountUI();
            buildPaletteUI();
        }));
    }

    async function init() {
        const sim = window.LogicCraft?.simulation;
        if (!sim) {
            console.error('[LogicCraft UI] sim (window.LogicCraft.simulation) ainda não está pronto.');
            return;
        }

        const yieldThread = () => new Promise(resolve => {
            if (typeof scheduler !== 'undefined' && scheduler.yield) {
                scheduler.yield().then(resolve);
            } else {
                setTimeout(resolve, 0);
            }
        });

        // 1. Inicializa renderizador WebGL e cena 3D
        sim.init();
        await yieldThread();

        // 2. Registra eventos interativos da UI e atalhos
        initUIEvents();
        initKeyboardShortcuts();
        initCollapsiblePanels();
        updateInputCountUI();
        await yieldThread();

        // 3. Monta a paleta de componentes em lote
        buildPaletteUI();
        await yieldThread();
        
        // 4. Carrega estado salvo ou circuito demonstrativo inicial
        const savedData = core.loadCircuitFromLocalStorage();
        const hasSavedComponents = savedData && (
            (Array.isArray(savedData) && savedData.length > 0) ||
            (savedData.components && Array.isArray(savedData.components) && savedData.components.length > 0)
        );
        if (hasSavedComponents) {
            sim.importCircuitFromFile(JSON.stringify(savedData));
        } else {
            sim.loadBcdExample();
        }
        await yieldThread();
        
        // 5. Exibe onboarding apenas se necessário (não-bloqueante)
        if (localStorage.getItem('logiccraft_onboarded') !== 'true') {
            const onboarding = document.getElementById('onboarding-screen');
            if (onboarding) onboarding.classList.add('open');
        }
    }

    return { 
        init, 
        showToast, 
        togglePointerHint, 
        renderTruthTableModal, 
        renderFundamentalsModal, 
        renderKarnaughModal, 
        closeAllModals 
    };
})();

window.addEventListener('DOMContentLoaded', () => {
    requestAnimationFrame(() => {
        setTimeout(() => {
            window.LogicCraft.ui.init();
        }, 50);
    });
});